<template>
    <div class="signBox">
        <breadcrumb :routerList="[{to:'/agent/agentCopy',title:'经销商管理'},{title:'经销商详情'}]"/>
        <div class="imgBox" v-loading="loading">
            <div class="bannerBox">
                <div class="whiteBox">
                    <div>
						<div class="h-pieceTitle2" style="margin-bottom: 0;">
                            <h1>经销商类型</h1>
						</div>
                        <el-radio-group v-model="radio" disabled @change="changeType" style="margin:20px 0 ;">
                            <el-radio-button label="国内客户"></el-radio-button>
<!--                            <el-radio-button label="上海直销"></el-radio-button>-->
                            <el-radio-button label="海外客户"></el-radio-button>
                        </el-radio-group>
                        <!--                        <div v-if="isShowMassage">-->
                        <!--                            <div class="titles">账户信息</div>-->
                        <!--                            <div class="zhanghu">-->
                        <!--                                <div class="h-formLine" style="margin-top:0.38rem">-->
                        <!--                                    <el-form :model="formLabelAlign1.bscUserInfo" label-position="right"-->
                        <!--                                             ref="formLabelAlign1a" :inline="true"-->
                        <!--                                             :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">-->
                        <!--                                        <el-form-item label="用户名" class="h-elformWrap-2" prop="username">-->
                        <!--                                            <el-input readonly v-model="formLabelAlign1.bscUserInfo.username"-->
                        <!--                                                      placeholder="请填写"></el-input>-->
                        <!--                                        </el-form-item>-->
                        <!--                                        <el-form-item label="密码" class="h-elformWrap-2" prop="password"-->
                        <!--                                                      v-if="this.flag==='1'">-->
                        <!--                                            <el-input readonly v-model="formLabelAlign1.bscUserInfo.password"-->
                        <!--                                                      placeholder="请填写" type="password"></el-input>-->
                        <!--                                        </el-form-item>-->
                        <!--                                    </el-form>-->
                        <!--                                    <div style="text-align:right;width:100%;margin-top:-4.5%;">-->
                        <!--                                        <el-form :model="check" label-position="right" ref="formLabelAlign1b"-->
                        <!--                                                 :inline="true" :rules="rules"-->
                        <!--                                                 class="demo-ruleForm h-formbLine h-formbLine1">-->
                        <!--                                            <el-form-item label="确认密码" class="h-elformWrap-2" prop="checkpassword"-->
                        <!--                                                          v-if="this.flag==='1'">-->
                        <!--                                                <el-input readonly v-model="check.checkpassword" placeholder="请填写"-->
                        <!--                                                          type="password"></el-input>-->
                        <!--                                            </el-form-item>-->
                        <!--                                        </el-form>-->
                        <!--                                    </div>-->
                        <!--                                </div>-->
                        <!--                            </div>-->
                        <!--                        </div>-->
                        <div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
                            <h1>直单类型</h1>
                        </div>
                        <div style="margin-top: 5px;">
                            <el-switch
                                    disabled
                                    v-model="isZhiDan"
                                    class="zhidangc"
                                    active-text="是否是直单用户"
                                    style="margin-bottom: 0.2rem"
                                    inactive-text="">
                            </el-switch>
                            <span>
                                <el-switch
                                    disabled
                                    style="margin-left: 50px;margin-bottom: 0.2rem"
                                    v-model="isExpandAuthority"
                                    active-text="是否开通海外下单权限">
                                </el-switch>
                            </span>
                        </div>
                        <!-- 海外下单：{{this.data.isExpandAuthorityBas}} -->
						<div class="h-pieceTitle2" style="margin-bottom: 0;">
						    <h1>客户资质信息</h1>
              <el-button class="h-btn h-bBtn h-bgblueQ2" style="margin-left: 0.4rem;" @click="pinggu">
                引入评估
              </el-button>
						</div>
                        <div class="signsign">
                            <div class="h-formLine" style="margin-top:0.38rem">
                                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                                         ref="formLabelAlign1c" :inline="true"
                                         :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="公司名称" class="h-elformWrap-2" prop="customerName1">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                                                  :title="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
												  >
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="客户编码" class="h-elformWrap-2" prop="usercode">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.usercode"
                                                  placeholder="">
                                        </el-input>
                                    </el-form-item>
                                    <el-form-item label="客户" class="h-elformWrap-2" v-if="this.agentType != 3" prop="scale">
                                        <el-select disabled v-model="formLabelAlign1.bscUserInfoAgentBasic.scale"
													:class="{'ljjSelectdisabled':true}"
                                                   placeholder="小规模经营者">
                                            <el-option label="小规模经营者" value="0"></el-option>
                                            <el-option label="一般纳税人" value="1"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="公司地址" class="h-elformWrap-2" prop="companyAddress">
                                        <el-input readonly
                                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
												  :title="formLabelAlign1.bscUserInfoAgentBasic.companyAddress"
                                                  placeholder=""></el-input>
                                    </el-form-item>
                                    <!--                                    <el-form-item label="邮政编码" class="h-elformWrap-2" prop="postalCode">-->
                                    <!--                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.postalCode" maxlength="6" show-word-limit-->
                                    <!--                                            placeholder="请填写"></el-input>-->
                                    <!--                                    </el-form-item>-->
                                    <el-form-item label="公司邮箱" class="h-elformWrap-2" prop="email">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.email"
                                                  ></el-input>
                                    </el-form-item>
                                    <el-form-item label="公司性质" class="h-elformWrap-2" v-if="this.agentType != 3" prop="companytype">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.companytype"
                                                  placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="成立时间" class="h-elformWrap-2" prop="founded">
                                        <el-date-picker
                                                disabled
                                                v-model="formLabelAlign1.bscUserInfoAgentBasic.founded"
                                                type="date"
												:class="{'ljjSelectdisabled':true}"
                                                placeholder="">
                                        </el-date-picker>
                                    </el-form-item>
                                    <el-form-item label="总经理姓名" class="h-elformWrap-2" prop="legal">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.legal"
                                                  placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="年度营业规模(万元)" class="h-elformWrap-2" prop="achievement">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.achievement"
                                                  placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="联系人" class="h-elformWrap-2" prop="name1">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.name1"
                                                  placeholder=""></el-input>
                                    </el-form-item>
                                    <!--                                    <el-form-item label="接口人城市" class="h-elformWrap-2" prop="contactCity" v-show="this.agentType===1||this.agentType===2">-->
                                    <!--                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity"-->
                                    <!--                                            placeholder="请填写"></el-input>-->
                                    <!--                                    </el-form-item>-->
                                    <!--                                    <el-form-item label="接口人称谓" class="h-elformWrap-2" prop="appellation" v-show="this.agentType===1||this.agentType===2">-->
                                    <!--                                        <el-select disabled v-model="formLabelAlign1.bscUserInfoAgentBasic.appellation"-->
                                    <!--                                                placeholder="请选择">-->
                                    <!--                                            <el-option label="先生" value="先生"></el-option>-->
                                    <!--                                            <el-option label="女士" value="女士"></el-option>-->
                                    <!--                                        </el-select>-->
                                    <!--                                    </el-form-item>-->
                                    <el-form-item label="联系人手机号" class="h-elformWrap-2" prop="phoneNumber1">
                                        <el-input readonly
                                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone"
                                                  placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="所在国家" class="h-elformWrap-2" prop="country">
                                        <brselectlazy category="YLCountry_agent"
                                                      :v="formLabelAlign1.bscUserInfoAgentBasic.country"
                                                      v-model="formLabelAlign1.bscUserInfoAgentBasic.country"
													  :class="{'ljjSelectdisabled':true}"
                                                      :clearable="true" disabled/>
                                    </el-form-item>
                                    <el-form-item label="直销/分销" v-if="this.agentType == '3'" class="h-elformWrap-2" prop="isZhidan">
                                        <el-select disabled v-model="formLabelAlign1.bscUserInfoAgentBasic.isZhidan"
													:class="{'ljjSelectdisabled':true}"
                                                   placeholder="">
                                            <el-option label="直销" value="1"></el-option>
                                            <el-option label="分销" value="0"></el-option>
                                        </el-select>
                                    </el-form-item>
                                    <el-form-item label="所在地区" class="h-elformWrap-2" prop="region"
                                                  v-show="this.isShowMassage === true ? true:false && this.agentType != '3'">
                                        <brselectlazy category="YLRegion"
                                                      :v="formLabelAlign1.bscUserInfoAgentBasic.region"
                                                      v-model="formLabelAlign1.bscUserInfoAgentBasic.region"
													  :class="{'ljjSelectdisabled':true}"
                                                      :clearable="true" disabled/>
                                    </el-form-item>
                                    <el-form-item label="所在城市" class="h-elformWrap-2" prop="companyAddress" v-if="this.isShowMassage !== true ? false:true && this.agentType != '3'">
                                        <el-select
                                                filterable
                                                disabled
                                                v-model="formLabelAlign1.bscUserInfoAgentBasic.contactCity"
												:class="{'ljjSelectdisabled':true}"
                                                placeholder="">
                                            <el-option v-for="(item,index) in addli" :key="index" :label="item" :value="item">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                    <!-- <el-form-item label="备注" v-if="this.agentType == '3'" class="h-elformWrap-2">
                                        <el-input v-model="formLabelAlign1.bscUserInfoAgentBasic.remark"
                                                  readonly placeholder=""></el-input>
                                    </el-form-item> -->
                                    <!--                                    <el-form-item label="公司代码(集团内)" class="h-elformWrap-2" prop="companyCodeGeneral"-->
                                    <!--                                                  v-show="this.agentType===1">-->
                                    <!--                                        <el-input readonly-->
                                    <!--                                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.companyCodeGeneral"-->
                                    <!--                                                  maxlength="4" show-word-limit-->
                                    <!--                                                  placeholder="请填写集团4位公司代码"></el-input>-->
                                    <!--                                    </el-form-item>-->

                                    <!--                                    <el-form-item label="纳税人登记号" class="h-elformWrap-2" prop="taxCode"-->
                                    <!--                                                  v-show="this.agentType===1||this.agentType===2">-->
                                    <!--                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.taxCode"-->
                                    <!--                                                  maxlength="18" show-word-limit-->
                                    <!--                                                  placeholder="请填写"></el-input>-->
                                    <!--                                    </el-form-item>-->
                                </el-form>
                            </div>
                        </div>
						<div class="h-pieceTitle2" style="margin-bottom: 0;">
						    <h1>开票信息</h1>
							<span style="font-size: 14px;color: #a8a8a8;margin-left:19px;">凡是贵公司相关信息的变更请及时通知，以便及时调整，保证开票信息无误</span>
						</div>
                        <div class="signsign">
                            <div class="h-formLine" style="margin-top:0.38rem">
                                <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right"
                                         ref="formLabelAlign1d" :inline="true"
                                         :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="客户名称" class="h-elformWrap-2" prop=customerName1>
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
												:title="formLabelAlign1.bscUserInfoAgentBasic.customerName1"
                                                  placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="纳税人登记号" class="h-elformWrap-2" prop="taxCode"
                                                  v-show="this.agentType===1||this.agentType===2">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.taxCode"
                                                  placeholder=""></el-input>
                                    </el-form-item>
                                    <!--                                    <el-form-item label="所在城市" class="h-elformWrap-2" prop="cityStreetRoom">-->
                                    <!--                                        &lt;!&ndash;                                        <el-select disabled v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"&ndash;&gt;-->
                                    <!--                                        &lt;!&ndash;                                                   placeholder="请选择">&ndash;&gt;-->
                                    <!--                                        &lt;!&ndash;                                            <el-option label="山东烟台" value="山东烟台"></el-option>&ndash;&gt;-->
                                    <!--                                        &lt;!&ndash;                                            <el-option label="山东青岛" value="山东青岛"></el-option>&ndash;&gt;-->
                                    <!--                                        &lt;!&ndash;                                        </el-select>&ndash;&gt;-->
                                    <!--                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"-->
                                    <!--                                                  placeholder="请填写"></el-input>-->
                                    <!--                                    </el-form-item>-->
                                    <!--                                    <el-form-item label="营业执照注册地址" class="h-elformWrap-2" prop="streetRoom">-->
                                    <!--                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.streetRoom"-->
                                    <!--                                                  placeholder="请填写"></el-input>-->
                                    <!--                                    </el-form-item>-->
                                    <el-form-item label="开票地址" class="h-elformWrap-2" prop="cityStreetRoom">
                                        <el-input clearable
												  :title="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom"
                                                  :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'"
                                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom">
                                            <!--                                            <i-->
                                            <!--                                                    class="el-icon-edit el-input__icon"-->
                                            <!--                                                    slot="suffix"-->
                                            <!--                                                    @click="handleIconClick">-->
                                            <!--                                            </i>-->
                                        </el-input>
                                        <areaSelect :visible.sync="showflag" @choseObj="choseObj" title="选择地址"
                                                    v-if="showflag"
                                                    v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"
                                                    :readonly="this.flag==='2'||this.flag==='3'||this.flag==='4'"/>
                                    </el-form-item>
                                    <el-form-item label="公司电话" class="h-elformWrap-2" prop="phoneNumber">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.phoneNumber"
                                                  placeholder=""></el-input>
                                    </el-form-item>
                                    <!--                                    <el-form-item label="邮政编码" class="h-elformWrap-2" prop="postalCode">-->
                                    <!--                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.postalCode" maxlength="6" show-word-limit-->
                                    <!--                                                  placeholder="请填写"></el-input>-->
                                    <!--                                    </el-form-item>-->
                                    <!-- <el-form-item label="联系人" class="h-elformWrap-2" prop="name1">
                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.name1"
                                                  placeholder=""></el-input>
                                    </el-form-item> -->
                                    <!--                                    <el-form-item label="联系电话" class="h-elformWrap-2" prop="phoneNumber1">-->
                                    <!--                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1"-->
                                    <!--                                                  placeholder="请填写"></el-input>-->
                                    <!--                                    </el-form-item>-->
                                    <el-form :model="formLabelAlign1.bscUserInfoAgentBank" label-position="right"
                                             ref="formLabelAlign1e" :inline="true"
                                             :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                        <!--                                        <el-form-item label="VAT税号" class="h-elformWrap-2" prop="vatCode">-->
                                        <!--                                            <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBank.vatCode"-->
                                        <!--                                                      placeholder="请填写"></el-input>-->
                                        <!--                                        </el-form-item>-->
                                        <el-form-item label="银行编号" class="h-elformWrap-2" prop="bankBranchCode">
                                            <el-input readonly
                                                      v-model="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"
                                                      onkeyup="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,'')}else{this.value=this.value.replace(/\D/g,'')}"
                                                      placeholder=""></el-input>
                                        </el-form-item>
                                        <el-form-item label="银行名称" class="h-elformWrap-2" prop="bankName">
                                            <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBank.bankName"
													:title="formLabelAlign1.bscUserInfoAgentBank.bankName"
                                                      placeholder=""></el-input>
                                        </el-form-item>
                                        <!--                                        <el-form-item label="银行名称" class="h-elformWrap-2" prop="bankBranchCode">-->

                                        <!--                                            <brselectlazy category="BankCategory_agent"-->
                                        <!--                                                          :v="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"-->
                                        <!--                                                          v-model="formLabelAlign1.bscUserInfoAgentBank.bankBranchCode"-->
                                        <!--                                                          :clearable="true"-->
                                        <!--                                                          disabled/>-->
                                        <!--                                        </el-form-item>-->
                                        <el-form-item label="银行账户号" class="h-elformWrap-2" prop="accountHolderName">
                                            <el-input readonly
                                                      v-model="formLabelAlign1.bscUserInfoAgentBank.accountHolderName"
                                                      placeholder=""></el-input>
                                        </el-form-item>
                                        <el-form-item label="银行所属国家" class="h-elformWrap-2" prop="bankCountry">
                                            <brselectlazy category="YLCountry_agent"
                                                          :v="formLabelAlign1.bscUserInfoAgentBank.bankCountry"
														  :class="{'ljjSelectdisabled':true}"
                                                          v-model="formLabelAlign1.bscUserInfoAgentBank.bankCountry"
                                                          :clearable="true" disabled/>
                                        </el-form-item>
                                    </el-form>
                                    <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                                             ref="formLabelAlign1f" :inline="true"
                                             :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                        <el-form-item label="发票类型" class="h-elformWrap-2" prop="customerGroup1">
                                            <el-select disabled placeholder=""
														:class="{'ljjSelectdisabled':true}"
                                                    v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup1">
                                                <el-option label="增值税发票" value="01"></el-option>
                                                <el-option label="普通发票" value="02"></el-option>
                                            </el-select>
                                        </el-form-item>
                                        <el-form-item label="国际贸易条件" class="h-elformWrap-2" prop="intCommercialTerms"
                                                    v-if="this.agentType == '3' || this.isExpandAuthority == true ">
                                            <brselectlazy category="YlCommercialTerms" :showcode="true"
                                                        :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms"
                                                        v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms"
                                                        disabled
                                                        :class="{'ljjSelectdisabled':true}"
                                                        :clearable="flase"/>
                                        </el-form-item>
                                        <el-form-item label="国际贸易条件2" class="h-elformWrap-2" prop="intCommercialTerms2"
                                                    v-if="this.agentType == '3'|| this.isExpandAuthority == true">
                                            <brselectlazy category="YlCommercialTerms" :showcode="true"
                                                        :v="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2"
                                                        v-model="formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2"
                                                        disabled
                                                        :class="{'ljjSelectdisabled':true}"
                                                        :clearable="flase"/>
                                        </el-form-item>
                                        <el-form-item label="货币种类" class="h-elformWrap-2" prop="currencyCode"  >
                                            <brselectlazy category="YLCurrency"
                                                        :v="formLabelAlign1.bscUserInfoAgentSell.currencyCode"
                                                        v-model="formLabelAlign1.bscUserInfoAgentSell.currencyCode"
                                                        :class="{'ljjSelectdisabled':true}"
                                                        :clearable="true" style="width:2.33rem" disabled/>
                                        </el-form-item>
                                      <el-form-item label="电票邮箱" class="h-elformWrap-2"
                                                    prop="inEmail" :required="this.isShowByHw"
                                                    v-if="">
                                        <el-input
                                            v-model="formLabelAlign1.bscUserInfoAgentSell.inEmail" disabled
                                        >
                                        </el-input>
                                      </el-form-item>
                                    </el-form>
                                </el-form>
                                <div style="text-align:center;width:100%;">

                                </div>
                                <!--                                <div style="text-align:center;width:100%;margin-top:-45px;">-->
                                <!--                                    <el-form :model="formLabelAlign1.bscUserInfoAgentBasic" label-position="right" ref="formLabelAlign1g"-->
                                <!--                                             :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">-->
                                <!--                                        <el-form-item label="邮箱" class="h-elformWrap-2" prop="email">-->
                                <!--                                            <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentBasic.email"-->
                                <!--                                                      :placeholder="this.flag==='2'||this.flag==='3'||this.flag==='4' ? '' : '请填写' "></el-input>-->
                                <!--                                        </el-form-item>-->
                                <!--                                    </el-form>-->
                                <!--                                </div>-->
                            </div>
                        </div>
						<div class="h-pieceTitle2" style="margin-bottom: 0;">
						    <h1>邮寄发票信息</h1>
						</div>
                        <div class="signsign">
                            <div class="h-formLine" style="margin-top:0.38rem">
                                <el-form :model="formLabelAlign1.bscUserInfoAgentCompany" label-position="right"
                                         ref="formLabelAlign1h" :inline="true"
                                         :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                    <el-form-item label="邮寄接收人" class="h-elformWrap-2" prop="mailreceiver">
                                        <el-input readonly
                                                  v-model="formLabelAlign1.bscUserInfoAgentCompany.mailreceiver"
                                                  placeholder=""></el-input>
                                    </el-form-item>
                                    <el-form-item label="电话" class="h-elformWrap-2" prop="receiverphone">
                                        <el-input readonly
                                                  v-model="formLabelAlign1.bscUserInfoAgentCompany.receiverphone"
                                                  placeholder=""></el-input>
                                    </el-form-item>
                                    <!--                                    <el-form-item label="邮寄地址" class="h-elformWrap-2" prop="mailaddress">-->
                                    <!--                                        <el-input readonly v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"-->
                                    <!--                                                  placeholder="请填写"></el-input>-->
                                    <el-form-item label="选择邮寄地址" class="h-elformWrap-2" prop="mailaddress">
                                        <el-input clearable readonly
												:title="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"
                                                  v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress">
                                            <!--                                            <i-->
                                            <!--                                                    class="el-icon-edit el-input__icon"-->
                                            <!--                                                    slot="suffix"-->
                                            <!--                                                    @click="handleIconClick">-->
                                            <!--                                            </i>-->
                                        </el-input>
                                        <areaSelect :visible.sync="showflag" @choseObj="choseObj" title="选择地址"
                                                    v-if="showflag"
                                                    v-model="formLabelAlign1.bscUserInfoAgentCompany.mailaddress"
                                                    readonly/>
                                    </el-form-item>
                                </el-form>

                            </div>
                        </div>
						<div class="h-pieceTitle2" style="margin-bottom: 0.2rem;">
						    <h1>上传附件</h1>
						</div>
                        <div class="h-formLine weekplandetail11">
                            <el-form :model="formLabelAlign1.bscUserInfoAgentCompany" label-position="right"
                                    ref="formLabelAlign1i" :inline="true"
                                    :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">
                                <el-form-item label="企业营业执照" class="h-elformWrap-2" prop="upload" v-if="this.agentType != '3'">
                                    <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-企业营业执照"
                                        :uploadflag="uploadflag" :delflag="delflag"
                                        :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="银行开户证明" class="h-elformWrap-2" prop="upload" v-if="this.agentType != '3'">
                                    <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-银行开户证明"
                                        :uploadflag="uploadflag" :delflag="delflag"
                                        :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                              <el-form-item label="企业营业执照有效截止日期" class="h-elformWrap-2" prop="yyzzEffectiveDate" v-if="this.agentType != '3'">
                                <el-date-picker
                                    style="width: 180px"  v-if="fileShowFlag"
                                    v-model="formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate"
                                    type="date"
                                    placeholder="选择日期">
                                </el-date-picker>
                              </el-form-item>
                                <el-form-item label="法人身份证" class="h-elformWrap-2" prop="upload" v-if="this.agentType != '3'">
                                    <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-法人身份证"
                                        :uploadflag="uploadflag" :delflag="delflag"
                                        :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="一般纳税人提供相关资质证明" class="h-elformWrap-2" prop="upload" v-if="this.agentType != '3'">
                                    <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-一般纳税人提供相关资质证明"
                                        :uploadflag="uploadflag" :delflag="delflag"
                                        :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="名称修改见证性资料" class="h-elformWrap-2" prop="upload">
                                    <brupload
                                            :refid="refid"
                                            reftype="代理商修改名称-见证性资料"
                                            :uploadflag="uploadflag"
                                            :delflag="delflag"
                                            :showtime="false">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="发票类型见证性资料" class="h-elformWrap-2" prop="upload">
                                    <brupload
                                            :refid="refid"
                                            reftype="代理商修改发票-见证性资料"
                                            :uploadflag="uploadflag"
                                            :delflag="delflag"
                                            :showtime="false">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="委托汇款的附件" class="h-elformWrap-2" v-if="this.agentType == '3'||agentType != 3 && isExpandAuthority">
                                    <brupload
                                            v-if="fileShowFlag"
                                            :refid="refid"
                                            reftype="代理商注册-委托汇款的附件"
                                            :uploadflag="uploadflag"
                                            :delflag="delflag"
                                            :showtime="false">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="" class="h-elformWrap-2" style="margin-left: 1.7rem;width: 45%;" v-if="this.agentType != '3'">
                                    <el-switch disabled v-model="have2" active-text="" inactive-text="是否有备案表">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item label="" class="h-elformWrap-2" style="width: 43%;padding-right: 0;padding-left: 0.8rem;" v-if="this.agentType != '3'">
                                    <el-switch disabled v-model="have3" active-text="" inactive-text="是否有许可证">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item label="备案表" class="h-elformWrap-2" prop="upload" v-show="have2 && this.agentType != '3'">
                                    <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-二类经营许可证"
                                        :uploadflag="uploadflag" :delflag="delflag"
                                        :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="" class="h-elformWrap-2" v-if="this.agentType != '3'">
                                    <div style="display:flex;align-items: center;width: 3.8rem;margin-left: 0.6rem;">
                                        <el-switch disabled style="" v-model="have6858" active-text=""
                                                inactive-text="是否包含6858">
                                        </el-switch>
                                        <el-switch disabled style="margin-left: 0.1rem;" v-model="have6840"
                                                active-text="" inactive-text="是否包含6840">
                                        </el-switch>
                                    </div>
                                </el-form-item>
                                <el-form-item label="" class="HAVES-2 h-elformWrap-1" v-if="this.agentType != '3'">
                                    <el-switch
                                            style="margin-left: 1rem"
                                            disabled
                                            v-model="havepolicy2017"
                                            active-text=""
                                            inactive-text="是否包含2017版分类目录">
                                    </el-switch>
                                    <el-switch
                                        style="margin-left: 0.4rem"
                                        disabled
                                        v-model="have1101"
                                        v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                                        active-text=""
                                        inactive-text="是否包含11-01">
                                    </el-switch>
                                    <el-switch
                                            style="margin-left: 0.4rem"
                                            disabled
                                            v-model="have2214"
                                            v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                                            active-text=""
                                            inactive-text="是否包含22-14">
                                    </el-switch>
                                    <el-switch
                                            style="margin-left: 0.4rem;"
                                            disabled
                                            v-model="have2215"
                                            v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                                            active-text=""
                                            inactive-text="是否包含22-15">
                                    </el-switch>
                                    <el-switch
                                            style="margin-left: 0.4rem;"
                                            disabled
                                            v-model="have2216"
                                            v-if="this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017 == 1"
                                            active-text=""
                                            inactive-text="是否包含22-16">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item label="许可证" v-if="this.agentType != '3'" class="h-elformWrap-2" prop="upload" v-show="have3">
                                    <brupload v-if="fileShowFlag" :refid="refid" reftype="代理商注册-三类经营许可证"
                                            :uploadflag="uploadflag" :delflag="delflag"
                                            :showtime="showtime">
                                    </brupload>
                                </el-form-item>
                                <el-form-item label="" class="h-elformWrap-2" v-if="this.agentType != '3'">
                                    <el-switch disabled style="margin-left: 2.1rem;width: 2rem;" v-model="have6854"
                                            active-text="" inactive-text="是否包含6854">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item label="许可证有效截止日期" class="h-elformWrap-2" prop="xkzEffectiveDate" v-show="have3">
                                  <el-date-picker
                                      style="width: 180px" disabled
                                      v-model="formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate"
                                      type="date"
                                      placeholder="选择日期">
                                  </el-date-picker>
                                </el-form-item>
                                <!--  补充  包含III类6840(体外诊断试剂 -->
                                <el-form-item class="h-elformWrap-5" v-if="this.agentType != '3'" >
                                    <el-switch
                                        disabled
                                        v-model="haveThree6840"
                                        @change="chooseIVD"
                                        inactive-text="是否包含III类6840(体外诊断试剂)">
                                    </el-switch>
                                </el-form-item>
                                <el-form-item label="三类经营许可证" class="h-elformWrap-2" v-if="this.haveThree6840 == true|| this.haveThree6840 == 1"
                                    :prop="this.haveThree6840 == true? 'upload8': '' ">
                                    <brupload
                                        v-model="formLabelAlign1.bscUserInfoAgentBasic.upload8"
                                        v-if="fileShowFlag"
                                        :refid="refid"
                                        reftype="三类6840经营许可证"
                                        :uploadflag="uploadflag"
                                        :delflag="delflag"
                                        @filecallback="fileBack1"
                                        :showtime="false">
                                    </brupload>
                                </el-form-item>
                            </el-form>
                            <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                                ref="formLabelAlign1i" :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1"
                                v-if="this.haveThree6840 == true">
                                <el-form-item label="许可证号" class="h-elformWrap-2"  v-if="this.haveThree6840 == true "
                                :prop="this.haveThree6840 == true? 'licenseNumber': '' " >
                                    <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.licenseNumber"  disabled
                                        placeholder="请输入许可证号" >
                                    </el-input>
                                </el-form-item>
                            </el-form>
                        </div>
                    </div>
					<div class="h-pieceTitle2" style="margin-bottom: 0.2rem;" v-if="this.flag==='2'||this.flag==='3'||this.flag==='4'||this.flag==='5'">
					    <h1>资质审核</h1>
					</div>
                    <div class="signsign" v-if="this.flag==='2'||this.flag==='3'||this.flag==='4' ||this.flag==='5'">
                        <div class="h-formLine" style="margin-top:0.38rem">
                            <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right"
                                    ref="formLabelAlign1j" :inline="true"
                                    :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">

                              <el-form-item label="  经销商类别" class="h-elformWrap-2" :class="{'gccolor':agentLevel}" prop="agentLevel" style="margin-left: 0.3rem;">
                                <div style="display: flex;margin-left: 0.2rem;">
                                  <brselect category="DealerCategory_type"  v-model="formLabelAlign1.bscUserInfoAgentBasic.agentLevel"
                                             :v="formLabelAlign1.bscUserInfoAgentBasic.agentLevel"
                                              disabled
                                             style="width: 1.5rem!important;margin-left: 0.2rem;"
                                             placeholder="请选择">
                                  </brselect>
                                </div>
                              </el-form-item>

                              <el-form-item label="对阵经销商" class="h-elformWrap-2" prop="oneLevelAgentName" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel==2 || formLabelAlign1.bscUserInfoAgentBasic.agentLevel==5">
                                <el-select v-model="formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName" :title="formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName" remote filterable :filter-method="showAgentList" clearable  placeholder="请输入"
                                           disabled
                                            >
                                  <el-option v-for="(item) in oneAgentList"
                                             :key="item.customerName"
                                             :label="item.customerName"
                                             :value="item">
                                  </el-option>
                                </el-select>
                              </el-form-item>
                              <div v-if="this.agentType!=3">
                                <el-form :model="formLabelAlign1" label-position="right"
                                         ref="formLabelAlign11"
                                         :inline="true"  class="demo-ruleForm h-formbLine h-formbLine1">
                                  <div v-for="(listIt, index) in formLabelAlign1.contractList" :key="index">
                                    <el-form-item label="合同号" class="h-elformWrap-2" prop="contractId">
                                      <el-input
                                          :title="formLabelAlign1.contractList[index].id"
                                          v-model="formLabelAlign1.contractList[index].id"
                                          disabled
                                      ></el-input>
                                    </el-form-item>
                                    <el-form-item label="目标对阵用户数量" class="h-elformWrap-2" prop="contractId">
                                      <el-input
                                          :title="formLabelAlign1.contractList[index].userNum"
                                          v-model="formLabelAlign1.contractList[index].userNum"
                                          disabled
                                      ></el-input>
                                    </el-form-item>
                                  </div>
                                </el-form>
                              </div>

                              <el-form-item label="链群" class="h-elformWrap-3" :class="{'gccolor':goodsCategory}" prop="goodsCategory" v-if="this.agentType!=3" style="margin-left: -0.5rem;">
<!--                                <item style="float: left">传统(</item>
                                <el-checkbox-group v-model="lianqunList"  style="float: left;margin-left: 10px;margin-right: 10px"  disabled>
                                  <el-checkbox label="X02">样本网</el-checkbox>
                                  <el-checkbox label="X01" >药品网</el-checkbox>
                                  <el-checkbox label="X08" >生物安全类</el-checkbox>
                                  <el-checkbox label="X09" >培养箱类</el-checkbox>
                                  <el-checkbox label="X10" >离心机</el-checkbox>
&lt;!&ndash;                                  <el-checkbox label="X07" >试剂网</el-checkbox>&ndash;&gt;
                                  <el-checkbox label="X11" >危化品</el-checkbox>
                                </el-checkbox-group>
                                <item style="float: left">)</item>-->
                                <el-checkbox-group v-model="lianqunListCt" @change="getLianqunTickct"  style="float: left;margin-left: 10px;margin-right: 10px" disabled>
                                  <el-checkbox label="ct">传统产品</el-checkbox>
                                </el-checkbox-group>
                                <el-checkbox-group v-model="LQcheckList" @change="LQSelect"  style="float: left;margin-left: 10px;margin-right: 10px" disabled>
                                      <el-checkbox :label="item.lianqun" v-for="(item,index) in LQList" :key="index">{{ item.companyName }}</el-checkbox>
                                </el-checkbox-group>
                              </el-form-item>
                              <el-form-item label="" class="h-elformWrap-1" prop="scale" style="margin-bottom: -0.3rem">
<!--                                  国内用-->
                                  <div v-if="this.agentType == 2">
                                    <!--                          传统产品-->
                                    <el-form-item label="" class="h-elformWrap-1" prop="scale" v-if="isCt" style="margin-left: -0.1rem;width: 100%;margin-top: -0.3rem">
                                      <!--                                        循环-->
                                      <div v-for="(listIt, index) in formLabelAlign1.ctList" :key="index">
                                        <div style="display: flex;flex-wrap: wrap;margin-top: 0.1rem;margin-bottom: 0.1rem" >

                                          <item style="float: left;margin-left: 0.9rem;color: #4a4a4a;">链群 传统(</item>
                                          <el-checkbox-group v-model="formLabelAlign1.ctList[index].lianqunList"  :v="formLabelAlign1.ctList[index].lianqunList" style="float: left;margin-left: 10px;margin-right: 10px"
                                          disabled
                                          >
                                            <el-checkbox label="X02">样本网</el-checkbox>
                                            <el-checkbox label="X01" >药品网</el-checkbox>
                                            <el-checkbox label="X08" >生物安全类</el-checkbox>
                                            <el-checkbox label="X09" >培养箱类</el-checkbox>
                                            <el-checkbox label="X10" >离心机</el-checkbox>
                                            <el-checkbox label="X05" >血液网</el-checkbox>
                                            <el-checkbox label="X06" >疫苗网</el-checkbox>
                                          </el-checkbox-group>
                                          <item style="float: left">)</item>
                                        </div>
                                        <div style="display: flex;flex-wrap: wrap;margin-top: 0.1rem;margin-bottom: 0.1rem;width: 110%">
                                          <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.9rem;">
                                            传统产品
                                          </div>
                                          <div style="display: flex;margin-left: 0.4rem;">
                                            <div class="foundation-box">
                                              领域:
                                            </div>
                                            <el-select v-if="ct" v-model="formLabelAlign1.ctList[index].field" @change="fieldSelect(index)" disabled
                                                       style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                       placeholder="请选择">
                                              <el-option v-for="item in fieldList"
                                                         :key="item.index"
                                                         :value="item.code"
                                                         :label="item.name"
                                                         :disabled="hasIncludeField(fields,item.code)"
                                              ></el-option>
                                            </el-select>
                                          </div>

                                          <div style="display: flex;margin-left: 0.4rem;">
                                            <div class="qudoa" :class="{'gccolor':formLabelAlign1.ctList[index].cheakChannel}">
                                              渠道:
                                            </div>
                                            <brselectlazy :multiple="true" category="sales_region_ct" disabled  style="width: 3.5rem"
                                                          :v="formLabelAlign1.ctList[index].channel"
                                                          v-model="formLabelAlign1.ctList[index].channel"
                                                          :class="{'ljjSelectdisabled':true}"
                                                          :clearable="true"/>
                                          </div>

                                          <div style="display: flex;margin-left: 0.4rem;">
                                            <div class="foundation-box">
                                              销售地区:
                                            </div>
                                            <brselect category="YlSalesArea_chanpin" v-model="formLabelAlign1.ctList[index].area"
                                                      style="width: 2rem!important;margin-left: 0.2rem;" disabled
                                                      :v="formLabelAlign1.ctList[index].area"></brselect>
                                          </div>
                                          <div class="h-elformWrap-1" style="display: flex;margin-left: 2rem;float: left;margin-top: 0.15rem;margin-bottom: 0.15rem">
                                            <div class="foundation-box" v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='3'">
                                              返利类型:
                                            </div>
                                            <el-select v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='6' && formLabelAlign1.bscUserInfoAgentBasic.agentLevel!='3'" v-model="formLabelAlign1.ctList[index].flType" @change="ctSelect"
                                                       style="width: 1.5rem!important;margin-left: 0.2rem;" disabled
                                                       placeholder="请选择">
                                              <el-option label="一级经销商" value="01"></el-option>
                                              <el-option label="地市直营商" value="06"></el-option>
                                              <el-option label="分销商3.0" value="05"></el-option>
                                            </el-select>
                                            <el-select v-if="ct && formLabelAlign1.bscUserInfoAgentBasic.agentLevel=='6'" v-model="formLabelAlign1.ctList[index].flType" @change="ctSelect"
                                                       style="width: 1.5rem!important;margin-left: 0.2rem;" disabled
                                                       placeholder="请选择">
                                              <el-option label="地市直营商" value="06"></el-option>
                                            </el-select>
                                            <div class="foundation-box" style="margin-left: 0.5rem;" :class="{'gccolor':formLabelAlign1.ctList[index].cheakLevel}">
                                              产品价格:
                                            </div>
                                            <el-select v-if="ct && isZhiDan!=1" v-model="formLabelAlign1.ctList[index].level" @change="ctSelect" disabled
                                                       style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                       placeholder="请选择">
                                              <el-option label="未签约" value=""></el-option>
                                              <el-option label="一级产品价格" value="01"></el-option>
                                              <el-option label="二级产品价格" value="02"></el-option>
                                              <el-option label="三级产品价格" value="03"></el-option>
                                              <!--                                                    <el-option label="直单价格" value="06"></el-option>-->
                                              <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>
                                            </el-select>
                                            <el-select v-if="ct && isZhiDan==1" v-model="formLabelAlign1.ctList[index].level" @change="ctSelect" disabled
                                                       style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                       placeholder="请选择">
                                              <el-option label="未签约" value=""></el-option>
                                              <el-option label="直单价格" value="04"></el-option>
                                            </el-select>
                                          </div>
                                        </div>
                                      </div>
                                    </el-form-item>
                                    <!--  0908 航空温控 动态修改 -->
                                    <el-form-item label="" class="h-elformWrap-1" v-for="(item,index) in checkLQAfterList" :key="index" prop="scale" style="margin-left: -0.1rem;width: 100%;margin-top: -0.4rem">
                                      <div style="display: flex;flex-wrap: wrap;margin-top: 0.1rem;margin-bottom: 0.1rem">
                                        <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.9rem;">
                                          <!-- 航空温控 -->
                                          {{ item.companyName }}
                                        </div>

                                        <div style="display: flex;margin-left: 2.3rem;">
                                          <div class="foundation-box">
                                          </div>
                                        </div>

                                        <div style="display: flex;margin-left: 0.98rem">
                                          <div class="qudoa">
                                            渠道:
                                          </div>
                                          <el-select @change="changeQudao" v-model="addForm[`${item.companyCode}Channel`]"  :disabled = 'true' :multiple="true" filterable placeholder="请选择" style="width: 3.5rem" >
                                             <el-option
                                              v-for="items in item.channelList"
                                              :key="items.code"
                                              :label="items.name"
                                              :value="items.code">
                                            </el-option>
                                          </el-select>
                                        </div>

                                        <div style="display: flex;margin-left: 0.4rem;">
                                          <div class="foundation-box">
                                            产品价格:
                                          </div>
                                          <el-select v-if="ct && isZhiDan!=1" v-model="addForm[`${item.companyCode}`]"
                                                     style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                     placeholder="请选择"
                                                     @change="changeQudao" disabled>
                                            <el-option label="未签约" value=""></el-option>
                                            <el-option label="一级产品价格" value="01"></el-option>
                                            <el-option label="二级产品价格" value="02"></el-option>
                                            <el-option label="三级产品价格" value="03"></el-option>
                                            <el-option label="分销商价格" value="05" v-if="formLabelAlign1.bscUserInfoAgentBasic.agentLevel != '1'"></el-option>
                                          </el-select>
                                          <el-select v-if="ct && isZhiDan==1" disabled v-model="addForm[`${item.companyCode}`]"
                                                     style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                     placeholder="请选择" @change="changeQudao">
                                            <el-option label="未签约" value=""></el-option>
                                            <el-option label="直单价格" value="04"></el-option>
                                          </el-select>
                                        </div>
                                      </div>
                                    </el-form-item>

                                  </div>

                                  <div v-if="this.agentType == 3">

                                    <div style="display: flex;" v-if="this.data.iszhidanBas !=1">
                                      <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 0.8rem;">
                                        产品价格
                                      </div>
                                      <div style="display: flex;margin-left: 0.7rem;">
                                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;" :class="{'gccolor':hct}">
                                          传统产品:
                                        </div>
                                        <el-select :disabled="this.flag==='2'||ctDisplay" v-if="ct"
                                                   v-model="ctLevel"
                                                   @change="ctSelect"
                                                   :class="{'ljjSelectdisabled':this.flag==='2'||ctDisplay}"
                                                   :placeholder="this.flag==='2'||ctDisplay?'':'请选择'"
                                                   style="width: 1.5rem!important;margin-left: 0.2rem;"
                                        >
                                          <el-option label="未签约" value=""></el-option>
                                          <el-option label="一级产品价格" value="01"></el-option>
                                          <el-option label="二级产品价格" value="02"></el-option>
                                          <el-option label="三级产品价格" value="03"></el-option>
                                          <!--                                                <el-option label="直单价格" value="06"></el-option>-->
                                          <el-option label="分销商价格" value="05"></el-option>
                                        </el-select>
                                      </div>
                                      <div style="display: flex;margin-left: 0.7rem;">
                                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;" :class="{'gccolor':hNA9}">航空温控:
                                        </div>
                                        <el-select :disabled="this.flag==='2'||NA9Display" v-if="NA9"
                                                   v-model="NA9Level"
                                                   style="width: 1.5rem!important;margin-left: 0.2rem;"
                                                   :class="{'ljjSelectdisabled':this.flag==='2'||NA9Display}"
                                                   :placeholder="this.flag==='2'||NA9Display?'':'请选择'"
                                                   @change="NA9Select" placeholder="请选择">
                                          <el-option label="未签约" value=""></el-option>
                                          <el-option label="一级产品价格" value="01"></el-option>
                                          <el-option label="二级产品价格" value="02"></el-option>
                                          <el-option label="三级产品价格" value="03"></el-option>
                                          <el-option label="分销商价格" value="05"></el-option>
                                        </el-select>
                                      </div>
                                    </div>
                                    <div style="display: flex;" v-if="this.data.iszhidanBas ==1">
                                      <div style="font-size: 0.18rem;color: #4a4a4a;line-height: 0.28rem;margin-left: 1.1rem;">
                                        产品组
                                      </div>
                                      <div style="display: flex;margin-left: 0.7rem;">
                                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;" :class="{'gccolor':hct}">传统产品:
                                        </div>
                                        <el-select :disabled="this.flag==='2'||ctDisplay" v-if="ct"
                                                   v-model="ctLevel"
                                                   :class="{'ljjSelectdisabled':this.flag==='2'||ctDisplay}"
                                                   :placeholder="this.flag==='2'||ctDisplay?'':'请选择'"
                                                   @change="ctSelect"
                                                   style="width: 1.5rem!important;margin-left: 0.2rem;">
                                          <el-option label="未签约" value=""></el-option>
                                          <el-option label="直单价格" value="04"></el-option>
                                        </el-select>
                                      </div>
                                      <div style="display: flex;margin-left: 0.7rem;">
                                        <div style="font-size: 0.18rem;color: #868686;line-height: 0.28rem;" :class="{'gccolor':hNA9}">航空温控:
                                        </div>
                                        <el-select :disabled="this.flag==='2'||NA9Display" v-if="NA9"
                                                   v-model="NA9Level"
                                                   :class="{'ljjSelectdisabled':this.flag==='2'||NA9Display}"
                                                   :placeholder="this.flag==='2'||NA9Display?'':'请选择'"
                                                   @change="NA9Select"
                                                   style="width: 1.5rem!important;margin-left: 0.2rem;">
                                          <el-option label="未签约" value=""></el-option>
                                          <el-option label="直单价格" value="04"></el-option>
                                        </el-select>
                                      </div>
                                    </div>
                                    <el-form-item label="主销售渠道" class="h-elformWrap-3 w-elformWrap other" :class="{'gccolor':customerGroup3}" prop="customerGroup3">
                                      <brselectlazy :multiple="true" category="sales_region"
                                                    :v="formLabelAlign1.bscUserInfoAgentSell.customerGroup3"
                                                    v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup3"
                                                    :clearable="true"
                                                    disabled/>
                                    </el-form-item>
                                    <el-form-item label="非主销售渠道" class="h-elformWrap-3 w-elformWrap other" :class="{'gccolor':customerGroup3NotMain}" prop="customerGroup3NotMain">

                                      <brselectlazy :multiple="true" category="sales_region"
                                                    :v="formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain"
                                                    v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain"
                                                    :clearable="true"
                                                    disabled/>
                                    </el-form-item>
                                  </div>
                                </el-form-item>

                                <el-form-item label="客户分配账户组" :class="{'gccolor':accountDistributeGroup}" class="h-elformWrap-2" prop="accountDistributeGroup" style="margin-left: 0.7rem;">
                                    <el-select v-model="formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup"
                                            :title="
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 10 ? '内销-海尔集团内（指国内市场所有海尔关联公司）':
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 20 ? '内销-海尔集团外（指国内市场所有非海尔关联公司）':
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 30 ? '外销-海尔集团内（指海外市场所有海尔关联公司）':
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 40 ? '外销-海尔集团外（指海外市场非海尔关联公司）':
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 50 ? '外销-合并范围内':
                                                formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup == 60 ? '内销-合并范围内':
                                                ''"
                                            :class="{'ljjSelectdisabled':true}"
                                            placeholder="" disabled>
                                      <el-option label="内销-海尔集团内（指国内市场所有海尔关联公司）-10" value="10"></el-option>
                                      <el-option label="内销-海尔集团外（指国内市场所有非海尔关联公司）-20" value="20"></el-option>
                                      <el-option label="外销-海尔集团内（指海外市场所有海尔关联公司）-30" value="30"></el-option>
                                      <el-option label="外销-海尔集团外（指海外市场非海尔关联公司）-40" value="40"></el-option>
                                      <el-option label="外销-合并范围内 -50" value="50"></el-option>
                                      <el-option label="内销-合并范围内 -60" value="60"></el-option>
                                    </el-select>
                                </el-form-item>
                                <!-- <el-form-item label="发票类型" :class="{'gccolor':hcustomerGroup1}" class="h-elformWrap-2" prop="scale">
                                    <el-select v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup1"
                                            :class="{'ljjSelectdisabled':true}"
                                            placeholder="" disabled>
                                        <el-option label="增值税发票" value="01"></el-option>
                                        <el-option label="普通发票" value="02"></el-option>
                                    </el-select>
                                </el-form-item> -->
                                <el-form-item label="客户组2" :class="{'gccolor':customerGroup2}" class="h-elformWrap-2" prop="scale">
                                    <el-select v-model="formLabelAlign1.bscUserInfoAgentSell.customerGroup2"
                                            :class="{'ljjSelectdisabled':true}"
                                            placeholder="" disabled>
                                        <el-option label="签约经销商" value="01"></el-option>
                                        <el-option label="非签约经销商" value="02"></el-option>
                                    </el-select>
                                </el-form-item>
                                <el-form-item label="分销渠道" :class="{'gccolor':distributionChannel}" class="h-elformWrap-2" prop="distributionChannel">
                                    <brselectlazy category="YlSalesChannel_agent" disabled
                                                  :v="formLabelAlign1.bscUserInfoAgentSell.distributionChannel"
                                                  v-model="formLabelAlign1.bscUserInfoAgentSell.distributionChannel"
                                                  :clearable="true"/>
                                </el-form-item>
                                <el-form-item label="销售区域" :class="{'gccolor':salesRegion}" class="h-elformWrap-3" prop="salesRegion">
                                    <brselectlazy :multiple="true" category="YlSalesArea_chanpin" disabled
                                                  :v="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                  :class="{'ljjSelectdisabled':true}"
                                                  v-model="formLabelAlign1.bscUserInfoAgentSell.salesRegion"
                                                  :clearable="true"/>
                                </el-form-item>
                                <el-form-item label="销售地市" class="h-elformWrap-3" prop="salesCity" :class="{'gccolor':salesCityC}" v-if="this.agentType != '3'">
                                  <el-select :multiple="true"
                                             :clearable="true"
                                             disabled
                                             v-model="formLabelAlign1.bscUserInfoAgentSell.salesCity"
                                             :v="formLabelAlign1.bscUserInfoAgentSell.salesCity"
                                             @change="getQudao"
                                             :placeholder="flag==='2'?'':'请选择'">
                                    <el-option v-for="item in salesCity"
                                               :key="item.index"
                                               :value="item.code"
                                               :label="item.name"
                                    ></el-option>
                                  </el-select>
                                </el-form-item>
                                <el-form-item label="公司代码" :class="{'gccolor':companyCode}" class="h-elformWrap-3" prop="companyCode">
                                    <brselectlazy category="YlCompanyCode_agent" :multiple="true" disabled
                                                  :v="formLabelAlign1.bscUserInfoAgentBasic.companyCode"
												  :class="{'ljjSelectdisabled':true}"
                                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.companyCode"
                                                  @change="companyCodeChange($event)"
                                                  :clearable="true"/>
                                </el-form-item>

                              <el-form-item label="附件" class="h-elformWrap-2" prop="upload9" v-if="isZhiDan">
                                <brupload
                                    v-model="formLabelAlign1.bscUserInfoAgentBasic.upload9"
                                    v-if="fileShowFlag"
                                    :refid="refid"
                                    reftype="代理商注册-附件"
                                    :uploadflag="uploadflag"
                                    :delflag="delflag"
                                    @filecallback="fileBack4"
                                    :showtime="false">
                                </brupload>
                              </el-form-item>

                              <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;" v-if="this.isFreezeData">
                                <h1>解冻信息</h1>
                              </div>
                              <el-form-item label="到期日调整" class="h-elformWrap-3" v-if="this.isFreezeData">
                                <el-date-picker type="date" placeholder="选择时间" class="h-tableInput" style="width: 20%;"  disabled v-model="formLabelAlign1.bscUserInfoAgentBasic.validityPeriodDate"
                                ></el-date-picker>
                              </el-form-item>
                              <el-form-item label="解冻原因" class="h-elformWrap-3"  v-if="this.isFreezeData">
                                <el-input type="textarea" disabled v-model="formLabelAlign1.bscUserInfoAgentBasic.reason"  :clearable="true" ></el-input>
                              </el-form-item>
                              <br>
                              <el-form-item label="上传附件" class="h-elformWrap-2" v-if="this.isFreezeData">
                                <brupload
                                    :refid="formLabelAlign1.bscUserInfoAgentBasic.instidThaw"
                                    reftype="代理商修改-解冻附件"
                                    :uploadflag="uploadflag"
                                    :delflag="delflag"
                                    :tpFlag = true
                                    :showtime="false"
                                >
                                </brupload>
                              </el-form-item>
                                <!-- 公司代码9390时，系统自动默认5个链群：-->
<!--                                <el-form-item label="链群" class="h-elformWrap-3" prop="goodsCategory" v-if="this.agentType!=3&&isShowAllSelect">
                                    <brselectlazy :multiple="true" category="YlGoods_category"
                                                  :v="formLabelAlign1.bscUserInfoAgentBasic.goodsCategory"
                                                  v-model="formLabelAlign1.bscUserInfoAgentBasic.goodsCategory"
                                                  :isCheckbox="isShowAllSelect"
                                                  disabled
                                                  :clearable="true"
                                                  style="width:100%"
                                    />
                                </el-form-item>-->
                                <!--isBlood  是否血站专用渠道（杨宝栋[01023980]）  1 是  0 不是-->
<!--                                <span  style="padding-left: 62px" v-if="this.agentType!=3">
                                    <el-switch style="margin-left: 62px"
                                               v-model="isBlood"
                                               :disabled="$store.getters.user.usercode == '01023980'?false:true"
                                               active-text="是否血站专用渠道">
                                    </el-switch>
                                </span>-->
                            </el-form>
                        </div>
                    </div>
                  <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;" v-if="this.agentType!=3">
                    <h1>修改附件记录</h1>
                  </div>

                  <el-table
                      ref="multipleTable"
                      :data="fileList"
                      stripe
                      border
                      v-if="this.agentType!=3"
                      style="width: 100%">
                    <el-table-column
                        type="index"
                        fixed
                        label="#"
                        width="40">
                    </el-table-column>
                    <el-table-column
                        prop="cuname"
                        label="修改人名称"
                        :show-overflow-tooltip="true"
                        fixed
                        min-width="90">
                    </el-table-column>
                    <el-table-column
                        prop="cucode"
                        label="修改人编码"
                        :show-overflow-tooltip="true"
                        fixed
                        min-width="110">
                    </el-table-column>
                    <el-table-column
                        prop="cdate"
                        label="修改时间"
                        :show-overflow-tooltip="true"
                        fixed
                        value-format="yyyy-MM-dd"
                        min-width="110">
                    </el-table-column>
                      <el-table-column
                              prop="reason"
                              label="修改原因"
                              :show-overflow-tooltip="true"
                              fixed
                              min-width="110">
                      </el-table-column>
                    <el-table-column
                        label="修改附件"
                        :show-overflow-tooltip="true"
                        fixed
                        min-width="110">
                      <template slot-scope="scope">
                        <brupload
                            :refid="scope.row.fileId"
                            reftype="代理商修改-修改附件"
                            :uploadflag="false"
                            :delflag="false"
                            :showtime="false">
                        </brupload>
                      </template>
                    </el-table-column>
                  </el-table>
                  <div style="display:flex;justify-content: flex-end;align-items:center;margin-top:20px" v-if="this.agentType!=3">
                    <paginationmin :page="mf" @query="agentUpdateFile"/>
                  </div>
                </div>
                <!--                <div class="titles" style="margin-top:0" >资质审核</div>-->
                <!--                <div class="signsign" >-->
                <!--                    <div class="h-formLine" style="margin-top:0.38rem">-->
                <!--                        <el-form :model="formLabelAlign1.bscUserInfoAgentSell" label-position="right" ref="formLabelAlign1j"-->
                <!--                                 :inline="true" :rules="rules" class="demo-ruleForm h-formbLine h-formbLine1">-->
                <!--                            <el-form-item label="审核意见" class="h-elformWrap-2" prop="email" >-->
                <!--                                <el-input v-model="formLabelAlign1.bscUserInfoAgentSell.auditMind2"-->
                <!--                                          placeholder="请填写审核意见"></el-input>-->
                <!--                            </el-form-item>-->
                <!--                        </el-form>-->
                <!--                    </div>-->
                <!--                </div>-->

                <div class="bannerBox2">
                    <div class="h-row h-mrt1">
                        <div class="h-rowIn">
                            <div class="h-rowBox">
                                <div class="h-rowCon">
                                    <div class="h-pieceIn2">
                                        <!-- <div style="height:30px;color:#303030;font-size:0.18rem;margin-bottom:20px;border-bottom:1px solid #dadfe0;font-weight:600">新增需求</div> -->
                                        <div class="h-pieceTitle2" style="margin-bottom: 0.3rem;">
                                            <h1>审核信息</h1>
                                        </div>
                                        <div class="h-pieceCon2 ">
                                            <div class="h-formLine weekplandetail11" style="position: relative;">
                                                <el-form :inline="true" :model="formLabelAlign1.bscUserInfoAgentSell">
                                                    <el-form-item label="审批意见" class="h-elformWrap-2 newBox"
                                                                  style="width: 100%!important;">
                                                        <el-input
                                                                v-model="formLabelAlign1.bscUserInfoAgentSell.auditMind2"
                                                                placeholder="请输入"></el-input>
                                                    </el-form-item>
                                                </el-form>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div style="text-align: center;margin-top: 0.3rem">
                <el-button class="h-btn h-bBtn" :class="{'h-bgwhite':this.flag!=='2'&&this.flag!=='5'}"
                           v-if="this.flag==='1'||this.flag==='2'||this.flag==='3'||this.flag==='4'||this.flag==='5'"
                           @click="goBack">返回
                </el-button>
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="insert('formLabelAlign1')"
                           v-if="this.flag==='1'">提交
                </el-button>
                <el-button class="h-btn h-bBtn h-bgred"
                           v-if="(this.flag==='3'||this.flag==='4') && this.lastflag"
                           @click="reject('formLabelAlign1')">驳回
                </el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="update()"
                           v-if="(this.flag==='3'||this.flag==='4') && this.lastflag">通过
                </el-button>
                <el-button class="h-btn h-bBtn h-bgred" @click="agentPassDaquBh()"
                           v-if="this.daquflag">驳回
                </el-button>
                <el-button class="h-btn h-bBtn h-bggreen" @click="agentPassDaqu()"
                           v-if="this.daquflag">通过
                </el-button>

            	<el-button class="h-btn h-bBtn" @click="viewpress">
            	    审批跟踪
            	</el-button>

            </div>
      <viewscoreShenPi :visible.sync="showscoretable" v-if="showscoretable" @choseObj="getChoose" :usercodeInfo="usercodeInfo" :instid="instid" />
			<viewhistory :visible.sync="showhistory" v-if="showhistory"
			             :id="instid"/>
        </div>
    </div>
</template>
<script>
    import ss from '../../../api/SystemService';
    import agentCopyService from "../../../api/loud/agent/agentCopyService";

    export default {
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.check.checkpassword !== '') {
                        this.$refs.formLabelAlign1a.validateField('checkpassword');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.formLabelAlign1.bscUserInfo.password) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            var validateCompany = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入公司名称'));
                } else if (value !== '') {
                    ss.SignService.checkCompany(value).then(response => {
                        this.companyData = response.obj.data;
                        console.log(response, '验证公司信息')
                        if (response.obj.status === '200') {
                            callback();
                            this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.companyData.address;
                            // this.formLabelAlign1.bscUserInfoAgentBasic.http = this.companyData.websites[0].web_url;
                            this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.companyData.econ_kind;
                            this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.companyData.start_date;
                            this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.companyData.regist_capi;
                            this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.companyData.oper_name;
                            this.formLabelAlign1.bscUserInfoAgentBasic.business = this.companyData.scope;
                            this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.companyData.credit_no;
                            this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.companyData.address;
                            this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.companyData.contact.telephone;
                        } else {
                            callback(new Error('请输入正确的公司名称!'));
                        }
                    })

                }
            };
            return {
                isBlood:false,//isBlood  是否血站专用渠道  1 是  0 不是
                isShowAllSelect:false,//判断是否展示全部群连并checkout
                haveThree6840:false,
                ctDisplay: true,
                NA9Display: true,
                ctLevel: '',
                NA9Level: '',
                ct: true,
                NA9: true,
                isCt:false,
                isNA9:false,
                checkedlevels: [],
                fileList:[],
                levels: ['传统产品', 'U血液',  'U疫苗'],
                checkAll: false,
                isIndeterminate: true,
                havepolicy2017:false,
                have6858: false,
                have6840: false,
                have6854: false,
                have1101: false,
                have2214: false,
                have2215: false,
                have2216: false,
                showhistory: false,
                showscoretable:false,
                instid: null,
                showtime: false,
                companyData: null,
                showflag: false,
                have: false,
                have2: false,
                have3: false,
                isZhiDan: false,
                isExpandAuthority:false,
                options: [],
                value: [],
                listSelect: [],
                changedParamList: [],
                addli: [],
                lianqunList:[],
                lianqunListCt:[],
                loadingSelect: false,
                states: [],
                isShowMassage: true,
                radio: '国内客户',
                fileShowFlag: false,
                uploadflag: true,
                delflag: true,
                daquflag:false,
                lastflag:true,
                refid: this.$util.getUuid(),
                loading: false,
                salesCityC:false,
                iszhuche:false,//是否是注册流程
                ind: null,
                usercodeInfo:null,
                scoreType: "check",
                index: ['a', 'b', 'c', 'd', 'e', 'f', 'h'],
                list: ["我是经销商", "我是供应商"],
                indx: 0,
                qudaoL1:[],
                qudaoL2:[],
                salesCity:[],
                fieldList:[
                  {name:'医疗创新领域',code:'L1'},
                  {name:'生命科学领域',code:'L2'}
                ],
               qudaoNotMain:[],
                fields:[],
                formLabelAlign1: {
                    bscUserInfoAgentBasic: {
                        usercode: null,
                        customerNumber: null,
                        accountGroup: null, // 科目组 , 配置项 , 调接口参数: YlCustomerAccountGroup , 字段输入限制:  0210 集团内客户 0260 海外客户 0280 国内客户 根据客户实际情况传入科目组代码  , 特殊限制:   付款条件销售平台更改
                        customerName1: '', // 客户全称1 ,  ,   , 字段输入限制: 客户全名。国内客户要求与证件注册的名称相同 , 特殊限制:   更改账期接口（公司销售视图付款条件字段）
                        customerTitle: null, // 客户标题 ,  ,   , 字段输入限制:  公司 先生 女士 先生和夫人 一般公司类客户数据，可以默认传入“公司”  ,
                        searchTerm: null, // 搜索项 ,  ,   ,   ,
                        postalCode: null, // 邮政编码 ,  ,   ,   ,
                        country: null, // 国家代码 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 传入国家的代码，在list中选择 ,
                        region: null, // 地区 , 配置项 , 调接口参数: YlRegion , 字段输入限制: 传入地区的代码，在国家代码下的list中选择 ,
                        cityStreetRoom: '', // 城市 ,  ,   , 字段输入限制: 客户所在的城市中文名 ,
                        streetRoom: null, // 街道 ,  ,   , 字段输入限制: 客户证件上的注册地址 ,
                        phoneNumber: null, // 电话 ,  ,   , 字段输入限制: 客户证件上注册的电话，开发票使用 , 特殊限制: 最多16位
                        language: null, // 语言代码 , 配置项 , 调接口参数: YlLanguageType , 字段输入限制: 默认传入“ZH” ,
                        faxNumber: null, // 传真 ,  ,   ,   , 特殊限制: 最多16位
                        contactMobilePhone: null, // 移动电话 ,  ,   ,   , 特殊限制: 最多16位
                        companyCodeGeneral: null, // 公司代码(记录0210账户组下客户公司对照关系) , 配置项 , 调接口参数: CompanyCode , 字段输入限制: 当建立集团内客户时，此字段不能为空，需传入集团4位公司代码 ,
                        companyCode: null, // 公司代码 , 是否必填: 是 , 是否配置项: 是 , 值集代码: YlCompanyCode , 注释:
                        taxCode: null, // 纳税人登记号 ,  ,   , 字段输入限制: 客户证件注册的统一信用代码，开发票使用 ,
                        name1: null, // 联系人名称 ,  ,   , 字段输入限制: 客户方联系人的名字 ,
                        phoneNumber1: null, // 联系人电话1 ,  ,   , 字段输入限制: 客户方联系人的电话 , 特殊限制: 最多16位
                        companyAddress: null, // 公司地址名 ,  ,   ,   ,
                        contactCity: null, // 联系人城市 ,  ,   ,   ,
                        appellation: null, // 称谓 ,  ,   , 字段输入限制:  女士 先生  ,
                        partnerFlagSp: null, // 是否有售达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagSh: null, // 是否有送达方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagBp: null, // 是否有开票方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        partnerFlagPy: null, // 是否有付款方功能,1:有;0:无 ,  ,   , 字段输入限制: 默认传“1” , 特殊限制: 一旦创建不可修改
                        cucode: null, //创建人编码
                        cuname: null, //创建人名称
                        cdate: null, //创建时间
                        lucode: null, //修改人编码
                        ldate: null, //最后更新时间
                        delflag: null, //可用标志。1：可用，0：删除标志
                        scale: null, //纳税人规模  0：小规模经营者   1：一般纳税人
                        http: null, //公司网址
                        companytype: null, //公司性质
                        founded: null, //成立时间
                        regmoney: null, //注册资本
                        legal: null, //法人姓名
                        introduce: null, //公司简介
                        business: null, //主营
                        achievement: null, //业绩
                        personnelNum:null,//销售人员数量
                        brand:null,//经营其他品牌
                        legalPhone:null,//总经理联系方式
                        resource: null, //资源
                        email: null, //公司邮箱
                        remark: null,//备注
                        agentLevel:null,
                        oneLevelAgent:null,
                        oneLevelAgentName:null,
                        upload9:null,
                        ontractId:null,//经销商签约合同
                    },
                    bscUserInfoAgentBank: {
                        usercode: null, //公司编码
                        accountHolderName: null, // 银行帐户 ,  ,   , 字段输入限制: 开户许可证上的银行账号 ,
                        bankCountry: null, // 银行所属国家 , 配置项 , 调接口参数: YlCountry , 字段输入限制: 从国家列表中选择 ,
                        bankBranchCode: null, // 银行码 , 配置项 , 调接口参数: 从MDM开放的银行接口中选择 , 字段输入限制: 从MDM开放的银行接口中选择 ,
                        cucode: null, //创建人编码
                        cuname: null, //创建人名称
                        cdate: null, //创建时间
                        lucode: null, //修改人编码
                        ldate: null, //最后更新时间
                        delflag: null, //可用标志。1：可用，0：删除标志
                        vatCode: null, //VAT税号
                        bankName: null //银行名称
                    },
                    bscUserInfoAgentSell: {
                        usercode: null, //公司编码
                        distributionChannel: null, // 分销渠道 , 配置项 , 调接口参数: YlSalesChannel ,   ,
                        division: null, // 产品组 , 配置项 , 调接口参数: YLProductGroup , 字段输入限制: 默认00 ,
                        salesGroup: null, // 销售组织 , 配置项 , 调接口参数: YLSalesOrganization ,   ,
                        salesRegion: null, // 销售地区 , 配置项 , 调接口参数: YlSalesArea ,   ,
                        customerGroup: null, // 客户组(经销商级别) , 配置项 , 调接口参数: YlCustomerGroup , 字段输入限制: 内销必填 ,
                        currencyCode: null, // 货币代码 , 配置项 , 调接口参数: YlCurrency ,   ,
                        customerPricingProccess: null, // 客户定价过程 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
                        customerSummaryGroup: null, // 客户统计组 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
                        shipCondition: null, // 装运条件 , 配置项 , 调接口参数: 默认传01 , 字段输入限制: 默认传01 ,
                        shipPlant: null, // 交货工厂 , 配置项 , 调接口参数: YlPLPlantCode ,   ,
                        accountDistributeGroup: null, // 客户组的帐户分配 , 配置项 , 调接口参数: YlAccountDistributeGroup ,   ,
                        custTaxCategory: null, // 客户的税分类 , 配置项 , 调接口参数: 默认传1 , 字段输入限制: 默认传1 ,
                        paymentTerms1: null, // 付款条件-未包含在最近模板 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认传0000 ,
                        podRelation: null, // 与 POD 处理相关 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        orderPossibility: null, // 订单可能性 ,  ,   ,   ,
                        intCommercialTerms: null, // 国际贸易条件 , 配置项 , 调接口参数: YlCommercialTerms , 字段输入限制: 外销必填 ,
                        intCommercialTerms2: null, // 国际贸易条件(部分2) ,  ,   , 字段输入限制: 外销必填 ,
                        fullDelivery: null, // 全部交货 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        partDelivery: null, // 每个项目允许的部分交货最大数 ,  ,   , 字段输入限制: 默认传9 ,
                        orderComposeIdentif: null, // 订单组合标识 ,  ,   , 字段输入限制: 传X或空  默认传X ,
                        customerGroup1: null, // 客户组 1(开票类型) , 配置项 , 调接口参数: YlCustomerGroup1 , 字段输入限制: 内销必填 ,
                        customerGroup2: null, // 客户组 2(经销商类型) , 配置项 , 调接口参数: YlCustomerGroup2 , 字段输入限制: 内销必填 ,
                        customerGroup3: null, // 客户组 3(渠道类型) , 配置项 , 调接口参数: YlCustomerGroup3 , 字段输入限制: 内销必填 ,
                        rebate: null, // 回扣 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        closeRoundingOff: null, // 关闭舍入 ,  ,   , 字段输入限制: 传X或空  默认传空 ,
                        permit: null, //资质标识 1二级 2三级
                        cucode: null, //创建人编码
                        cuname: null, //创建人名称
                        cdate: null, //创建时间
                        lucode: null, //修改人编码
                        ldate: null, //最后更新时间
                        delflag: null, //可用标志。1：可用，0：删除标志
                        customerAssignGroup: null, //客户分配账户组: 10内销-集团内 20内销-集团外
                        auditMind1: null, //审核意见
                        auditMind2: null, //审核意见
                        licenseNumber:'',
                        haveThree6840:'',
                        customerGroup3NotMain:'',
                        inEmail: null, //邮箱
                    },
                    bscUserInfoAgentCompany: {
                        usercode: null, //公司编码
                        companyCode: null, // 公司代码 , 配置项 , 调接口参数: YlCompanyCode ,   ,
                        hq: null, // 总部 ,  ,   ,   ,
                        reconcileAccount: null, // 统驭科目 , 配置项 , 调接口参数: YLReconcileAccount , 字段输入限制:  0230、0260、0280账户组默认1122002000 0210默认1122001000  ,
                        sequenceNo: null, // 排序码 , 配置项 , 调接口参数: YlOrderCode , 字段输入限制: 默认001 ,
                        paymentTerm: null, // 付款条款 , 配置项 , 调接口参数: YlPayTerm , 字段输入限制: 默认0000 ,
                        cucode: null, //创建人编码
                        cuname: null, //创建人名称
                        cdate: null, //创建时间
                        lucode: null, //修改人编码
                        ldate: null, //最后更新时间
                        delflag: null, //可用标志。1：可用，0：删除标志
                        mailreceiver: null, //邮寄接收人
                        receiverphone: null, //接收人电话
                        mailaddress: null, //邮寄地址
                    },
                    bscUserInfo: {
                        usercode: null, //员工编码/公司编码
                        password: '', //密码
                        usertype: null, //用户类别: 0-内部员工  1-经销商  2-供应商
                        username: '', //公司名称/员工姓名username
                        email: null, //邮箱
                        phone: null, //联系人电话
                        deptcode: null, //所属部门编码deptcode  公司用户为空
                        userdept: null, //用户详细部门userdept  公司用户为空
                        deptname: null, //部门名称deptname  公司用户为空
                        firstline: null, //一线经理firstline  公司用户为空
                        secondline: null, //二线经理secondline  公司用户为空
                        status: null, //用户状态: 0--禁用/冻结  1--正常  2--用户被删除
                        organization: null, //公司地址/住址机构
                        cdate: null, //创建时间
                        ldate: null, //更新时间
                        logintimes: null, //登录次数: 记录登录尝试失败次数，登录失败5次就将status改为禁止，联系运维解开
                        lastlogintime: null, //最后登录时间: 记录最后登录时间
                        accountdate: null, //账户有效期
                        area: null, //负责区域
                        lucode: null, //更新人编码
                        countrytype: null, //1- 国内  /  2- 国外   账户
                        fileId: null,
                        aaa: null,
                        taskid: null,
                    },
                    bscUserInfoAgentScore:{
                    usercode: null,
                    customerName1: null, //客户全称1
                    staffing:"",
                    scale:"",
                    qualification:"",
                    brandPower:"",
                    businessPower:"",
                    conclusion:"",
                    daquConfirm:"",
                    quyuConfirm:"",
                  },
                    levelMap: {},
                    contractList:[],
                    OperateType: null,
                    OPERATOR: null,
                    ctList: [{
                      field:'',//领域
                      channel:'',//渠道
                      channelList:[],//渠道
                      level:'',//等级
                      num: null,
                      lianqun:'',
                      lianqunList:[],//链群
                      cheakChannel: false,
                      cheakLevel: false,
                      showLq : false,
                    }],
                    NA9Channel:'',
                    cheakNA9Level:false,
                    NA9List: [{
                      channel:'',//渠道
                      level:'',//等级
                      num: null,
                    }],
                },
                mf: {
                  pageSize: 10,
                  pageNo: 1,
                  total: 0,
                  userCode:null,
                },
                data: {},
                check: {
                    checkpassword: ''
                },
                rules: {
                    username: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    password: [{
                        required: true,
                        validator: validatePass,
                        trigger: 'blur'
                    },],
                    checkpassword: [{
                        required: true,
                        validator: validatePass2,
                        trigger: 'blur'
                    },],
                    customerName1: [{
                        required: true,
                        validator: validateCompany,
                        trigger: 'blur'
                    },],
                    companyAddress: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    phoneNumber1: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    cityStreetRoom: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    streetRoom: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    phoneNumber: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    bankBranchCode: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    bankName: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    accountHolderName: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                    customerGroup1: [{
                        required: true,
                        message: '请填写必填项',
                        trigger: 'blur'
                    },],
                },
                flag: '',
                modelList: [],
                agentType: 1,
                taskstatus: null,
                hct: false,
                hNA9: false,
                companyCode: false,
                accountDistributeGroup: false,
                hcustomerGroup1: false,
                customerGroup2: false,
                distributionChannel: false,
                customerGroup3: false,
                customerGroup3NotMain: false,
                salesRegion: false,
                goodsCategory: false,
                agentLevel: false,
                isFreezeData:false,
                checkLQAfterList: [],// 选中链群之后渲染的列表
                signingList: [],// 签约的链群
                LQcheckList:[],// 选中的链群
                LQList: [],// 渲染链群
                addForm: {},// 链群对象数据
            }
        },
        created() {
            console.log(this.$route.query, 'query')
            this.findAddress();
            this.getLqList();// 获取链群数据
            agentCopyService.checkChange(this.$route.query.ywid).then(res => {
                this.changedParamList = res;
                console.log(this.changedParamList,"什么变了");
                if (this.changedParamList.includes("companyCode")) {
                    this.companyCode = true;
                }
                if (this.changedParamList.includes("accountDistributeGroup")) {
                    this.accountDistributeGroup = true;
                }
                if (this.changedParamList.includes("customerGroup1")) {
                    this.hcustomerGroup1 = true;
                }
                if (this.changedParamList.includes("customerGroup2")) {
                    this.customerGroup2 = true;
                }
                if (this.changedParamList.includes("distributionChannel")) {
                    this.distributionChannel = true;
                }
                if (this.changedParamList.includes("customerGroup3")) {
                    this.customerGroup3 = true;
                }
                if (this.changedParamList.includes("salesCity")) {
                  this.salesCityC = true;
                }
                if (this.changedParamList.includes("customerGroup3NotMain")) {
                  this.customerGroup3NotMain = true;
                }
                if (this.changedParamList.includes("salesRegion")) {
                    this.salesRegion = true;
                }
                if (this.changedParamList.includes("goodsCategory")) {
                  this.goodsCategory = true;
                }
                if (this.changedParamList.includes("agentLevel")) {
                  this.agentLevel = true;
                }
            })
            this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
            this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
            this.formLabelAlign1.bscUserInfoAgentCompany.sequenceNo = '001';
            this.formLabelAlign1.bscUserInfoAgentCompany.paymentTerm = '0000';
            this.formLabelAlign1.bscUserInfoAgentSell.division = '00';
            this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
            this.formLabelAlign1.bscUserInfoAgentSell.customerPricingProccess = '1';
            this.formLabelAlign1.bscUserInfoAgentSell.customerSummaryGroup = '1';
            this.formLabelAlign1.bscUserInfoAgentSell.shipCondition = '01';
            this.formLabelAlign1.bscUserInfoAgentSell.custTaxCategory = '1';
            this.formLabelAlign1.bscUserInfoAgentSell.paymentTerms1 = '0000';
            this.formLabelAlign1.OperateType = 'CREATE';
            this.formLabelAlign1.OPERATOR = this._user.username;
            this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = 'CN';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSp = '1';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagBp = '1';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagPy = '1';
            this.formLabelAlign1.bscUserInfoAgentBasic.partnerFlagSh = '1';
            var id = this.$route.query.ywid;
            this.formLabelAlign1.bscUserInfo.taskid = this.$route.query.taskid;
            this.instid = this.$route.query.instid;
            this.taskstatus = this.$route.query.taskstatus;
            agentCopyService.queryOne(id, "true").then(response => {
                console.log(response, 'response')
                //如果是从审批流进来的,查询暂存表中的数据
              if(null != this.$route.query.taskid) {
                ss.taskservice.getTaskByTaskid(this.$route.query.taskid).then(result => {
                  console.log("resultresultresult", result);
                  //判断大区经理审批节点控制审批按钮
                  if (result.name == '省区经理审批' || result.name == '省区经理审核' || result.name == '运营管理' || result.name == '总监审批') {
                    this.daquflag = true;
                    this.lastflag = false;
                    console.log('暂存')
                    this.queryLevelZc(response.obj.customergroupSell);
                    this.queryLevelZcList(response.obj.customergroupSell);
                  }
                  //如果是新增流程
                    if(result.beizhu.indexOf("账号注册") != -1){
                        this.iszhuche = true;
                    }
                  var name = false;
                  agentCopyService.getLqSelectList().then(res =>{
                    this.signingList = res
                    res.forEach((item,index)=>{
                      console.log("item.approvalNode",item.approvalNode)
                      if(item.approvalNode == result.name){
                        name = true;
                      }
                    });
                    if (result.name == '传统产品审批' || result.name == 'U血液审批'
                        || result.name == 'U疫苗审批' || result.name == 'U试剂审批'
                        || result.name == '航空温控审批' || result.name == '航空温控' || result.name == '链群主' || result.name == '审核人' || name) {
                      console.log('暂存')
                      this.queryLevelZc(response.obj.customergroupSell);
                      if(result.beizhu.indexOf("账号注册") != -1){
                        this.queryLevelZcList1(response.obj.customergroupSell);
                      }else {
                        this.queryLevelZcList(response.obj.customergroupSell);
                      }
                    }
                  });
                })
              }else {
                console.log('经销商')
                this.queryLevel(response.obj.customergroupSell);
              }
                this.data = response.obj;
                if (response.obj.permitSell == 2) {
                    this.have2 = true;
                } else if (response.obj.permitSell == 3) {
                    this.have3 = true;
                } else if (response.obj.permitSell == 5) {
                    this.have3 = true;
                    this.have2 = true;
                }
                this.uploadflag = false;
                this.delflag = false;
                this.rules = {};
                if (this.taskstatus == '1') {
                    this.flag = '5';
                } else {
                    this.flag = '4';
                }
                this.refid = this.data.fileidInfo;
                this.fileShowFlag = true;
                this.checkDetail();
                console.log(this.refid, 'refid')
                // if (response.obj.customerassigngroupSell === '0280' || response.obj.agentTypeBas == '1') {
                if (response.obj.agentTypeBas == '1') {
                    this.radio = '国内客户';
                    this.agentType = 2;
                // } else if (response.obj.customerassigngroupSell === '0210' || response.obj.agentTypeBas == '2') {
                } else if (response.obj.agentTypeBas == '2') {
                    this.radio = '上海直销';
                    this.agentType = 1;
                // } else if (response.obj.customerassigngroupSell === '0260' || response.obj.agentTypeBas == '3') {
                } else if (response.obj.agentTypeBas == '3') {
                    this.radio = '海外客户';
                    this.agentType = 3;
                    this.isShowMassage = false;
                }
            })
        },
        methods: {
            // remoteMethod(query) {
            //     if (query !== '') {
            //         this.loadingSelect = true;
            //         setTimeout(() => {
            //             this.loadingSelect = false;
            //             this.options = this.listSelect.filter(item => {
            //                 console.log(item,'item111111111111111111111111111')
            //                 return item.label.toLowerCase()
            //                     .indexOf(query.toLowerCase()) > -1;
            //             });
            //         }, 200);
            //     } else {
            //         this.options = [];
            //     }
            // },
            findAddress() {
                ss.SignService.selectAddress().then(response => {
                    this.addli = response;
                })
            },
            queryLevel(v) {
                agentCopyService.queryLevel(v).then(response => {
                    console.log(response, 'levelmap')
                    if (response.ct != undefined) {
                        this.checkedlevels.push("传统产品");
                        this.ctLevel = response.ct;
                        this.ct = true;
                        this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
                    }
                    if (response.NA9 != undefined) {
                      this.checkedlevels.push("航空温控");
                      this.NA9Level = response.NA9;
                      this.NA9 = true;
                      this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
                    }
                })
            },

          queryLevelZc(v) {
            agentCopyService.queryLevelZc(v).then(response => {
              console.log(response, 'levelmap')
              if (response.ct != undefined) {
                this.checkedlevels.push("传统产品");
                this.ctLevel = response.ct;
                this.ct = true;
                this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
              }
              if (response.NA9 != undefined) {
                this.checkedlevels.push("航空温控");
                this.NA9Level = response.NA9;
                this.NA9 = true;
                this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
              }
            })
          },

          queryLevelZcList(v){
            agentCopyService.checkChangeLevelList(v).then(response => {
              console.log(response, 'levelmap11111111')
              let filteredObject = {};
              let p = new Set(Object.keys(response));
              let blacklist = ['ct'];
              blacklist.forEach(a => p.delete(a));
              [...p].forEach(k => filteredObject[k] = response[k]);
              this.addForm = filteredObject;
              console.log(this.addForm,'设置设置是的hi山东i山东i是')
              if (response.ct != undefined) {
                if(response.ct.length >= 1){
                  this.checkedlevels.push("传统产品");
                  this.formLabelAlign1.ctList = response.ct;
                  this.ct = true;
                  this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
                  this.lianqunListCt.push("ct");
                  this.getLianqunTickct(this.lianqunListCt);
                  this.getQudaoCt();
                }
              }
              if (response.NA9 != undefined) {
                this.checkedlevels.push("航空温控");
                this.NA9Level = response.NA9.level;
                this.formLabelAlign1.NA9Channel = response.NA9.channel;
                this.formLabelAlign1.cheakNA4Level = response.NA9.cheakChannel;
                this.NA9 = true;
                this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
              }
            })
          },
          queryLevelZcList1(v){
            agentCopyService.queryLevelZcList(v).then(response => {
              console.log(response, 'levelmap11111111账号注册')
              let filteredObject = {};
              let p = new Set(Object.keys(response));
              let blacklist = ['ct'];
              blacklist.forEach(a => p.delete(a));
              [...p].forEach(k => filteredObject[k] = response[k]);
              this.addForm = filteredObject;
              console.log(this.addForm,'设置设置是的hi山东i山东i是')
              if (response.ct != undefined) {
                if(response.ct.length >= 1){
                  this.checkedlevels.push("传统产品");
                  this.formLabelAlign1.ctList = response.ct;
                  for(var item in this.formLabelAlign1.ctList){
                    var m = this.formLabelAlign1.ctList[item].channel.split(',');
                    if (m.length <= 0) {
                      this.formLabelAlign1.ctList[item].channelList = '';
                    }else {
                      this.formLabelAlign1.ctList[item].channelList = m;
                    }
                  }
                  this.ct = true;
                  this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
                  this.lianqunListCt.push("ct");
                  this.getLianqunTickct(this.lianqunListCt);
                }
              }
              if (response.NA9 != undefined) {
                this.checkedlevels.push("航空温控");
                this.NA9Level = response.NA9.level;
                this.formLabelAlign1.NA9Channel = response.NA9.channel;
                this.NA9 = true;
                this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
              }
            })
          },
            ctSelect() {
                this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
            },
            NA9Select() {
              this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
            },
            handleCheckAllChange(val) {
                console.log(val, '全选')
                if (val) {
                    this.ct = true;
                    this.NA9 = true;
                    this.formLabelAlign1.levelMap.ct = this.ctLevel;
                    this.formLabelAlign1.levelMap.NA9 = this.NA9Level;
                } else {
                    this.ct = false;
                    this.NA9 = false;
                    this.formLabelAlign1.levelMap = {};
                }
                this.checkedlevels = val ? this.levels : [];
                this.isIndeterminate = false;

            },
            handleCheckedCitiesChange(value) {
                console.log(value, '级别分类')
                this.ct = false;
                this.NA9 = false;
                this.formLabelAlign1.levelMap = {};
                for (var i = 0; i < value.length; i++) {
                    if (value[i] == '传统产品') {
                        this.ct = true;
                        this.formLabelAlign1.levelMap['ct'] = this.ctLevel;
                    }else if (value[i] == '航空温控') {
                      this.NA9 = true;
                      this.formLabelAlign1.levelMap['NA9'] = this.NA9Level;
                    }
                }
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.levels.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.levels.length;
            },
            viewpress() {
                this.showhistory = true;
            },
            handleIconClick() {
                this.showflag = true;
            },
            hasIncludeField(arr = [],item){
              return arr.includes(item)
            },
            choseObj(obj) {
                console.log(obj)
                this.showflag = false;
                if (obj.zhenobj && obj.zhenobj.name) {
                    this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.zhenobj.name + ' ' + obj.addrdetail;
                } else {
                    this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = obj.shengobj.name + ' ' + obj.shiobj.name + ' ' + obj.quobj.name + ' ' + obj.addrdetail;
                }
            },
            //是否开通体外试剂
            chooseIVD(){
                if (this.haveThree6840) {
                    this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = 1;
                    console.log("包含")
                } else {
                    this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840 = 0;
                    console.log("不包含III类6840")
                }
            },
            changeType(v) {
                if (v === '海外客户') {
                    this.agentType = 3;
                    this.isShowMassage = false;
                    this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0260';
                    this.formLabelAlign1.bscUserInfoAgentBasic.country = '';
                    this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
                } else if (v === '上海直销') {
                    this.agentType = 1;
                    this.isShowMassage = true;
                    // this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0210';
                    // this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
                    // this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122001000';
                    // this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
                    this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
                    this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
                    this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
                    this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
                } else if (v === '国内客户') {
                    this.agentType = 2;
                    this.isShowMassage = true;
                    this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = '0280';
                    this.formLabelAlign1.bscUserInfoAgentBasic.country = 'CN';
                    this.formLabelAlign1.bscUserInfoAgentCompany.reconcileAccount = '1122002000';
                    this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = 'CNY';
                }
            },
            //通过审批按钮功能
            update() {
                // this.formLabelAlign1.bscUserInfo.status = '4';
                // this.modelList.push(this.formLabelAlign1);
                // ss.SignService.update(this.modelList).then(response => {
                //     console.log(response)
                // })
                if(this.isBlood){
                    this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = 1;
                } else {
                    this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = 0;
                }
                this.formLabelAlign1.bscUserInfo.aaa = 1;
                this.formLabelAlign1.ywid = this.$route.query.ywid;
                // this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = 'CFR';
                // this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = 'CIF';
                this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.citys

                this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategoryNew = this.LQcheckList.join(',')
                let levelMapNew = JSON.parse(JSON.stringify(this.formLabelAlign1.levelMap))

                let levelObjNew = Object.assign({},levelMapNew,this.addForm);

                for (let key in levelObjNew) {
                  if(key == 'ct') {

                  } else {
                    if(Array.isArray(levelObjNew[key])) {
                      console.log(levelObjNew[key],"是数组")
                      levelObjNew[key] = levelObjNew[key].join()
                    }
                  }
                }
                this.formLabelAlign1.levelMap = levelObjNew;
                console.log(this.formLabelAlign1,"提交修改数据")
                console.log("1111",this.formLabelAlign1);

                var isDs = false;
                //判断地市直营商
                for(var i=0;i<this.formLabelAlign1.ctList.length;i++){
                  if(this.formLabelAlign1.ctList[i].flType == '06' ){
                      isDs = true;
                  }
                }
                if(isDs){
                  this.$msg.confirm("是否确认签约合同为地市直营商?", () => {
                    agentCopyService.agentPass2(this.formLabelAlign1).then(rd => {
                      this.$msg.alerts("提交成功！", () => {
                        //刷新右上角的代办个数
                        this.$store.dispatch("searchTasktotal")
                        //跳转回系统的代办列
                        this.$router.go(-1);
                        // this.$router.push({
                        //     path: '/personal/dealCenter'
                        // })
                      })
                    });
                  });
                }else {
                  agentCopyService.agentPass2(this.formLabelAlign1).then(rd => {
                    this.$msg.alerts("提交成功！", () => {
                      //刷新右上角的代办个数
                      this.$store.dispatch("searchTasktotal")
                      //跳转回系统的代办列表
                      this.$router.go(-1);
                      // this.$router.push({
                      //     path: '/personal/dealCenter'
                      // })
                    })
                  });
                }

            },
            //驳回按钮功能
            reject(data) {
                if(this.formLabelAlign1.bscUserInfoAgentSell.auditMind2 && this.formLabelAlign1.bscUserInfoAgentSell.auditMind2 != ''){
                    this.formLabelAlign1.bscUserInfo.aaa = 2;
                    this.formLabelAlign1.ywid = this.$route.query.ywid;
                    this.formLabelAlign1.bscUserInfoAgentSell.salesCity = '';
                    if(this.isBlood){
                        this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = 1;
                    } else {
                        this.formLabelAlign1.bscUserInfoAgentBasic.isBlood = 0;
                    }
                    agentCopyService.agentPass2(this.formLabelAlign1).then(rd => {
                        if (rd.f == true) {
                            //刷新右上角的代办个数
                            this.$store.dispatch("searchTasktotal")
                            //跳转回系统的代办列表
                            this.$router.go(-1);
                        }
                    });
                    // var defaultpage = this._user.defaultpage;
                    // this.$router.push({
                    //     path: defaultpage
                    // });
                } else {
                    this.$msg.msge('请输入审批意见！')
                }

                // this.formLabelAlign1.bscUserInfo.status = '5';
            },
          //大区经理审批推动节点,无更改
          agentPassDaqu(){
            //如果是分销商2.0,新增流程
            if(this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel == 2 && this.iszhuche){
                this.update();
                return;
            }
            this.formLabelAlign1.bscUserInfo.aaa = 1;
            this.formLabelAlign1.ywid = this.$route.query.ywid;
            this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = '';
            this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = '';
            this.formLabelAlign1.bscUserInfoAgentSell.salesCity = '';
            this.formLabelAlign1.levelMap.ct = this.ctLevel;
            this.formLabelAlign1.levelMap.NA9 = this.NA9Level;
            this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategoryNew = this.LQcheckList.join(',')
            let levelMapNew = JSON.parse(JSON.stringify(this.formLabelAlign1.levelMap))

            let levelObjNew = Object.assign({},levelMapNew,this.addForm);

            for (let key in levelObjNew) {
              if(key == 'ct' ) {

              } else {
                if(Array.isArray(levelObjNew[key])) {
                  console.log(levelObjNew[key],"是数组")
                  levelObjNew[key] = levelObjNew[key].join()
                }
              }
            }
            this.formLabelAlign1.levelMap = levelObjNew;
            console.log(this.formLabelAlign1,"提交修改数据")
            console.log("1111",this.formLabelAlign1);


            var isDs = false;
            //判断地市直营商
            for(var i=0;i<this.formLabelAlign1.ctList.length;i++){
              if(this.formLabelAlign1.ctList[i].flType == '06' ){
                isDs = true;
              }
            }
            if(isDs){
              this.$msg.confirm("是否确认签约合同为地市直营商?", () => {
                agentCopyService.updateDaquPass(this.formLabelAlign1).then(rd => {
                  this.$msg.alerts("提交成功！", () => {
                    //刷新右上角的代办个数
                    this.$store.dispatch("searchTasktotal")
                    //跳转回系统的代办列表
                    this.$router.push({
                      path: '/personal/dealCenter'
                    })
                  })
                });
              });
            }else {
              agentCopyService.updateDaquPass(this.formLabelAlign1).then(rd => {
                this.$msg.alerts("提交成功！", () => {
                  //刷新右上角的代办个数
                  this.$store.dispatch("searchTasktotal")
                  //跳转回系统的代办列表
                  this.$router.push({
                    path: '/personal/dealCenter'
                  })
                })
              });
            }
          },
          // 获取修改记录
          agentUpdateFile() {
            this.mf.userCode = this.formLabelAlign1.bscUserInfoAgentBasic.usercode;
            console.log("this.mf",this.mf);
            //更新到期时间
            agentCopyService.agentUpdateFile(this.mf).then(rd =>{
              console.log("agentUpdateFile",rd)
              this.fileList = rd.records
              this.mf.total = rd.total
            });
          },
          //大区经理驳回
          agentPassDaquBh(){
            this.formLabelAlign1.bscUserInfo.aaa = 2;
            this.formLabelAlign1.ywid = this.$route.query.ywid;
            this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = '';
            this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = '';
            this.formLabelAlign1.bscUserInfoAgentSell.salesCity = '';
            this.formLabelAlign1.levelMap.ct = this.ctLevel;
            this.formLabelAlign1.levelMap.NA9 = this.NA9Level;
            agentCopyService.updateDaquPass(this.formLabelAlign1).then(rd => {
              this.$msg.alerts("提交成功！", () => {
                //刷新右上角的代办个数
                this.$store.dispatch("searchTasktotal")
                //跳转回系统的代办列表
                this.$router.push({
                  path: '/personal/dealCenter'
                })
              })
            });
          },


            //经销商查看功能对应展示数据功能
            checkDetail() {
                this.formLabelAlign1.bscUserInfo.usercode = this.data.usercodeInfo
                this.formLabelAlign1.bscUserInfoAgentBasic.usercode = this.data.usercodeBas
                this.formLabelAlign1.bscUserInfoAgentBank.usercode = this.data.usercodeBank
                this.formLabelAlign1.bscUserInfoAgentCompany.usercode = this.data.usercodeCom
                this.formLabelAlign1.bscUserInfoAgentSell.usercode = this.data.usercodeSell

                this.formLabelAlign1.bscUserInfo.username = this.data.usernameInfo
                this.formLabelAlign1.bscUserInfo.password = this.data.passwordInfo
                this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
                if (this.data.scaleBas !== undefined) {
                    this.formLabelAlign1.bscUserInfoAgentBasic.scale = this.data.scaleBas.toString()
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.isZhidan = this.data.iszhidanBas
                this.formLabelAlign1.bscUserInfoAgentBasic.agentType = this.data.agentTypeBas
                if (this.data.iszhidanBas == 1) {
                    this.isZhiDan = true;
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.isExpandAuthority = this.data.isExpandAuthorityBas
                if (this.data.isExpandAuthorityBas == 1) {
                    this.isExpandAuthority = true;
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.companyAddress = this.data.companyaddressBas
                this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.faxNumber = this.data.faxnumberBas
                this.formLabelAlign1.bscUserInfoAgentBasic.http = this.data.httpBas
                this.formLabelAlign1.bscUserInfoAgentBasic.companytype = this.data.companytypeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.founded = this.data.foundedBas
                this.formLabelAlign1.bscUserInfoAgentBasic.regmoney = this.data.regmoneyBas
                this.formLabelAlign1.bscUserInfoAgentBasic.legal = this.data.legalBas
                this.formLabelAlign1.bscUserInfoAgentBasic.introduce = this.data.introduceBas
                this.formLabelAlign1.bscUserInfoAgentBasic.business = this.data.businessBas
                this.formLabelAlign1.bscUserInfoAgentBasic.achievement = this.data.achievementBas
                this.formLabelAlign1.bscUserInfoAgentBasic.resource = this.data.resourceBas
                this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.contactMobilePhone = this.data.contactmobilephoneBas
                this.formLabelAlign1.bscUserInfoAgentBasic.customerName1 = this.data.customername1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.cityStreetRoom = this.data.citystreetroomBas
                this.formLabelAlign1.bscUserInfoAgentBasic.streetRoom = this.data.streetroomBas
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber = this.data.phonenumberBas
                this.formLabelAlign1.bscUserInfoAgentBasic.postalCode = this.data.postalcodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.name1 = this.data.name1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.phoneNumber1 = this.data.phonenumber1Bas
                this.formLabelAlign1.bscUserInfoAgentBasic.remark = this.data.remark
                this.formLabelAlign1.bscUserInfoAgentBasic.agentLevel = this.data.agentLevelBas+""
                this.formLabelAlign1.bscUserInfoAgentBank.vatCode = this.data.vatcodeBank
                this.formLabelAlign1.bscUserInfoAgentBank.bankBranchCode = this.data.bankbranchcodeBank
                this.formLabelAlign1.bscUserInfoAgentBank.bankName = this.data.banknameBank
                this.formLabelAlign1.bscUserInfoAgentBank.accountHolderName = this.data.accountholdernameBank
                if (this.data.customergroup1Sell !== undefined) {
                    this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell.toString()
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.email = this.data.emailBas
                this.formLabelAlign1.bscUserInfoAgentCompany.mailreceiver = this.data.mailreceiverCom
                this.formLabelAlign1.bscUserInfoAgentCompany.receiverphone = this.data.receiverphoneCom
                this.formLabelAlign1.bscUserInfoAgentCompany.mailaddress = this.data.mailaddressCom
                this.formLabelAlign1.bscUserInfoAgentSell.auditMind1 = this.data.auditmind1Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup = this.data.customergroupSell
                this.formLabelAlign1.bscUserInfoAgentSell.customerAssignGroup = this.data.customerassigngroupSell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup1 = this.data.customergroup1Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup2 = this.data.customergroup2Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3 = this.data.customergroup3Sell
                this.formLabelAlign1.bscUserInfoAgentSell.salesCity = this.data.salesCitySell

                if(this.data.salesCitySell != null && this.data.salesCitySell != '' && typeof(this.data.salesCitySell) != "undefined"){
                  var s1 = this.data.salesCitySell
                  var m  = s1.split(',');
                  if(m.length<=0){
                    this.formLabelAlign1.bscUserInfoAgentSell.salesCity = ''
                  }else {
                    this.formLabelAlign1.bscUserInfoAgentSell.salesCity = m
                    this.getCity(this.formLabelAlign1.bscUserInfoAgentSell.salesCity)
                  }
                }
                this.formLabelAlign1.bscUserInfoAgentSell.salesRegion = this.data.salesregionSell
                this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = this.data.intcommercialtermsSell
                this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = this.data.intcommercialterms2Sell
                this.formLabelAlign1.bscUserInfoAgentSell.licenseNumber = this.data.licenseNumberSell
                this.formLabelAlign1.bscUserInfoAgentSell.haveThree6840Sell = this.data.haveThree6840Sell
                this.formLabelAlign1.bscUserInfoAgentSell.customerGroup3NotMain = this.data.customergroup3NotMainSell
                this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms = this.data.intcommercialtermsSell
                this.formLabelAlign1.bscUserInfoAgentSell.intCommercialTerms2 = this.data.intcommercialterms2Sell
                this.formLabelAlign1.bscUserInfoAgentSell.xkzEffectiveDate = this.data.xkzEffectiveDateSell
                this.formLabelAlign1.bscUserInfoAgentSell.yyzzEffectiveDate = this.data.yyzzEffectiveDateSell
                if(this.data.haveThree6840Sell == 1){
                    this.haveThree6840 = true
                }
                this.formLabelAlign1.bscUserInfoAgentBasic.contactCity = this.data.contactcityBas
                this.formLabelAlign1.bscUserInfoAgentBasic.appellation = this.data.appellationBas
                this.formLabelAlign1.bscUserInfoAgentBasic.country = this.data.countryBas
                this.formLabelAlign1.bscUserInfoAgentBasic.region = this.data.regionBas
                this.formLabelAlign1.bscUserInfoAgentBasic.companyCodeGeneral = this.data.companycodegeneralBas
                this.formLabelAlign1.bscUserInfoAgentBasic.companyCode = this.data.companycodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = this.data.goodsCategoryBas
                this.isBlood = this.data.isBloodBas == 1?true:false;
                this.formLabelAlign1.bscUserInfoAgentBasic.taxCode = this.data.taxcodeBas
                this.formLabelAlign1.bscUserInfoAgentBasic.isFenxiao = this.data.isFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.statusFenxiao = this.data.statusFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.instidFenxiao = this.data.instidFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.signingFenxiao = this.data.signingFenxiaoBas;
                this.formLabelAlign1.bscUserInfoAgentBasic.oneLevelAgentName = this.data.oneLevelAgentNameBas
                this.formLabelAlign1.bscUserInfoAgentBasic.contractId = this.data.contractIdBas
                this.formLabelAlign1.bscUserInfoAgentBasic.instidThaw = this.data.instidThawBas
                this.formLabelAlign1.bscUserInfoAgentBank.bankCountry = this.data.bankcountryBank
                this.formLabelAlign1.bscUserInfoAgentSell.distributionChannel = this.data.distributionchannelSell
                this.formLabelAlign1.bscUserInfoAgentSell.salesGroup = this.data.salesgroupSell
                this.formLabelAlign1.bscUserInfoAgentSell.currencyCode = this.data.currencycodeSell
                this.formLabelAlign1.bscUserInfoAgentSell.accountDistributeGroup = this.data.accountdistributegroupSell
                this.formLabelAlign1.bscUserInfoAgentSell.inEmail = this.data.inEmailSell
                this.formLabelAlign1.bscUserInfoAgentSell.havepolicy2017= this.data.havepolicy2017Sell
                this.formLabelAlign1.bscUserInfoAgentSell.have6840 = this.data.have6840Sell
                this.formLabelAlign1.bscUserInfoAgentSell.have6854 = this.data.have6854Sell
                this.formLabelAlign1.bscUserInfoAgentSell.have6858 = this.data.have6858Sell
                this.formLabelAlign1.bscUserInfoAgentSell.have1101 = this.data.have1101Sell
                this.formLabelAlign1.bscUserInfoAgentSell.have2214 = this.data.have2214Sell
                this.formLabelAlign1.bscUserInfoAgentSell.have2215 = this.data.have2215Sell
                this.formLabelAlign1.bscUserInfoAgentSell.have2216 = this.data.have2216Sell

                 //如果有解冻原因,是解冻流程
                 if(null != this.data.reasonBas && this.data.reasonBas !=''){
                   this.formLabelAlign1.bscUserInfoAgentBasic.reason = this.data.reasonBas;
                   this.isFreezeData = true;
                 }
                this.formLabelAlign1.bscUserInfoAgentBasic.validityPeriodDate = this.data.validityPeriodDateBas;
                this.formLabelAlign1.bscUserInfoAgentScore.staffing = this.data.staffingSco
                this.formLabelAlign1.bscUserInfoAgentScore.scale = this.data.scaleSco
                this.formLabelAlign1.bscUserInfoAgentScore.qualification = this.data.qualificationSco
                this.formLabelAlign1.bscUserInfoAgentScore.brandPower = this.data.brandPowerSco
                this.formLabelAlign1.bscUserInfoAgentScore.businessPower = this.data.businessPowerSco
                this.formLabelAlign1.bscUserInfoAgentScore.conclusion = this.data.conclusionSco
                this.formLabelAlign1.bscUserInfoAgentScore.daquConfirm = this.data.daquConfirmSco
                this.formLabelAlign1.bscUserInfoAgentScore.quyuConfirm = this.data.quyuConfirmSco

              this.$nextTick(function () {
                    let str = this.formLabelAlign1.bscUserInfoAgentBasic.companyCode;
                    if (str && str.split(',').indexOf('9390') >= 0) {
                        this.isShowAllSelect = true;//判断是否展示全部群连并checkbox
                    }

                })
                if (this.data.have6840Sell == 1) {
                    this.have6840 = true;
                }
                if (this.data.have6854Sell == 1) {
                    this.have6854 = true;
                }
                if (this.data.have6858Sell == 1) {
                    this.have6858 = true;
                }
                if (this.data.havepolicy2017Sell == 1) {
                    this.havepolicy2017 = true;
                }
                if (this.data.have1101Sell == 1) {
                  this.have1101 = true;
                }
                if (this.data.have2214Sell == 1) {
                  this.have2214 = true;
                }
                if (this.data.have2215Sell == 1) {
                  this.have2215 = true;
                }
                if (this.data.have2216Sell == 1) {
                  this.have2216 = true;
                }
                if(this.data.goodsCategoryBas != null && this.data.goodsCategoryBas != ''){
                  let s = this.data.goodsCategoryBas;
                  this.getLianquns(s)
                  this.getLQs(s)
                  this.getLianqunTick(s)
                }
              this.agentUpdateFile();
                //如果是国内
              if(this.agentType != 3){
                this.getAreaCity();
              }
              //获取合同信息
              if(this.agentType != 3){
                ss.contractService.getContractByUsercode(this.formLabelAlign1.bscUserInfoAgentBasic.usercode).then(rd => {
                  if(rd.f){
                    console.log("rd",rd);
                    this.formLabelAlign1.contractList = rd.msg;
                  }
                })
              }
            },
              getLianquns(s){
                var m  = s.split(',');
                if(m.length<=0){
                  this.lianqunList = ''
                }else {
                  this.lianqunList = m
                }
              },
            fieldSelect(index){
              this.formLabelAlign1.ctList[index].channel = '';
              this.fields = [];
              for(var i=0;i<this.formLabelAlign1.ctList.length;i++){
                if(this.formLabelAlign1.ctList[i].field != null && this.formLabelAlign1.ctList[i].field != ''){
                  this.fields.push(this.formLabelAlign1.ctList[i].field);
                }
              }
            },
            goBack() {
                this.$router.push({
                    path: '/agent/agentCopy'
                })
            },
            getQudao(value){
              var jsonObj = value
              var jStr = '';
              for(var item in jsonObj){
                jStr += jsonObj[item]+",";
              }
              this.qudaos = jStr.substring(0, jStr.lastIndexOf(','))
              this.chflag++;
            },
            fileBack4(v) {
              console.log(v)
              this.formLabelAlign1.bscUserInfoAgentBasic.upload9 = v.length;
            },
            insert(formName) {
                var flag = 0;
                for (var i = 0; i < this.index.length; i++) {
                    this.ind = this.index[i];
                    var form = formName + this.ind;
                    // console.log(form)
                    this.$refs[form].validate((valid) => {
                        if (valid) {

                        } else {
                            flag = flag + 1;
                            return false;
                        }
                    });
                }
                // console.log(flag)
                if (flag !== 0) {
                    return false;
                }
                this.loading = true;
                this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategoryNew = this.LQcheckList.join(',')
                let levelMapNew = JSON.parse(JSON.stringify(this.formLabelAlign1.levelMap))

                let levelObjNew = Object.assign({},levelMapNew,this.addForm);

                for (let key in levelObjNew) {
                  if(key == 'ct') {

                  } else {
                    if(Array.isArray(levelObjNew[key])) {
                      console.log(levelObjNew[key],"是数组")
                      levelObjNew[key] = levelObjNew[key].join()
                    }
                  }
                }
                this.formLabelAlign1.levelMap = levelObjNew;
                console.log(this.formLabelAlign1,"提交修改数据")
                ss.SignService.insert(this.formLabelAlign1).then(response => {
                    if (response.f) {
                        this.$message({
                            type: "success",
                            message: response.msg
                        });
                        if (this.flag === '1' || this.flag === '3' || this.flag === '4') {
                            this.$router.push({
                                path: '/agent/agentCopy'
                            })
                        } else {
                            this.$router.push({
                                path: '/login'
                            })
                        }

                    } else {
                        this.$message({
                            type: "error",
                            message: response.msg
                        });
                        this.loading = false;
                    }
                })


            },
            go(index) {
                this.indx = index;
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            beforeRemove(file, fileList) {
                return this.$confirm(`确定移除 ${ file.name }？`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消'
				});

            },
            toLogin() {
                this.$router.push({
                    path: '/login'
                })
            },
            //公司代码改变回掉
            companyCodeChange(obj) {
                if (obj && obj.length > 0) {
                    let bool = false;
                    for (let item of obj) {
                        if (item.code == '9390') {
                            bool = true;
                        }else{
                            this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
                        }
                    }
                    if (bool) {
                        this.isShowAllSelect = true;//判断是否展示全部群连并checkbox
                        let s = this.formLabelAlign1.bscUserInfoAgentBasic.companyCode;
                        s = s.split(',');
                        if (s && s.length > 0 && s[s.length - 1] == '9390') {
                            ss.Dictservice.listbycategory('YlGoods_category').then(res => {
                                let arr = []
                                for (let item of res) {
                                    arr.push(item.code)
                                }
                                this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = arr.toString() || '';
                            })
                        }

                    } else {
                        this.isShowAllSelect = false;//判断是否展示全部群连并checkbox
                    }
                } else {
                    this.isShowAllSelect = false;//判断是否展示全部群连并checkbox
                    this.formLabelAlign1.bscUserInfoAgentBasic.goodsCategory = '';
                }
            },
          getLianqunTick(query){
            if(query.indexOf("X12") != -1){
              this.isNA9 = true;
            }else {
              this.isNA9 = false;
            }
          },
          getLianqunTickct(query){
            console.log("lianquns",query);
            if(query.indexOf("ct") != -1){
              this.isCt = true;
            }else {
              this.isCt = false;
            }
          },
          changeQudao(){
           this.formLabelAlign1.beUpdate++;
            this.chflag++;
            this.$forceUpdate();
          },
          getQudaoCt(qudaos){
            console.log("qudao",qudaos)
            this.qudaoListL1 =[];
            //获取所有渠道
            var jso = this.formLabelAlign1.ctList;
            for(var item in jso){
              var jsoElement = jso[item].channelList;
              for(var item in jsoElement){
                this.qudaoListL1.push(jsoElement[item])
              }
            }
            this.formLabelAlign1.beUpdate++;
            console.log("qudaoListL1",this.qudaoListL1)
          },
          // 查询链群list
          getLqList() {
            agentCopyService.getLqSelectList().then(res =>{
              this.LQList = res
              console.log(this.LQList,"获取获取获取")
            });
          },
          getLQs(s) {
            let that = this;
            agentCopyService.getLqSelectList().then(res =>{
              that.LQList = res
              var m  = s.split(',');
              if(m.length<=0){
                that.LQcheckList = []
              }else {
                that.LQcheckList = [...new Set(m)];
                this.LQSelect()
              }
            });
          },
          getCity(value){
            this.citys = value.join(",")
            console.log(this.citys);
          },
          getAreaCity(){
            let areas = this.formLabelAlign1.bscUserInfoAgentSell.salesRegion.split(",");
            console.log(areas, "areasareasareasareasareasareas")
            let ss1 = [];
            let promises = []; // 创建一个存储异步操作的Promise数组
            for (var i = 0; i < areas.length; i++) {
              let promise = ss.Dictservice.getDictByCateCode("YlSalesArea_chanpin", areas[i])
                  .then(response => {
                    ss1.push(response.refid);
                  });
              promises.push(promise); // 将每个异步操作的Promise添加到数组中
            }

            Promise.all(promises) // 等待所有异步操作完成
                .then(() => {
                  var s2 = ss1.join(",");
                  ss.UserService.getCityByArea(s2).then(rd => {
                    this.salesCity = rd.msg;
                  });
                });
          },
          pinggu() {
            this.showscoretable = true;
            this.usercodeInfo = this.formLabelAlign1.bscUserInfoAgentBasic.usercode;
          },
          // 新增
          LQSelect() {
            this.checkLQAfterList = [];
            let map = new Map();
            for (let item of this.LQList) {
                if (!map.has(item.lianqun)) {
                    map.set(item.lianqun, item);
                };
            };
            console.log(this.LQList)
            console.log(this.LQcheckList)
            this.checkLQAfterList = [...map.values()].filter(item => this.LQcheckList.includes(item.lianqun))
            console.log(this.checkLQAfterList,'hauifhdshfisdfhais')
            // 取消勾选项清空输入值
            let otherArr = [];
            for (let i = 0; i < this.LQList.length; i++) {
              let isExist = false;
              for (let j = 0; j < this.LQcheckList.length; j++) {
                if (this.LQList[i].lianqun === this.LQcheckList[j]) {
                  isExist = true;
                  break;
                }
              }
              if (!isExist) {
                otherArr.push(this.LQList[i]);
              }
            }
            if(this.addForm) {
              otherArr.forEach((el,index)=>{
                this.addForm[el.companyCode] = '';
                this.addForm[el.companyCode+ 'Channel'] = ''
              })
            }
            console.log(this.addForm)
            // this.$forceUpdate();
          },
        },
        mounted() {
            this.flag = this.$route.query.index;
            console.log(this.flag, 'flag');
            if (this.flag === '2') {
                this.uploadflag = false;
                this.delflag = false;
                this.data = this.$route.query;
                this.rules = {};
                this.checkDetail();
            } else if (this.flag === '3') {
                this.uploadflag = false;
                this.delflag = false;
                this.data = this.$route.query;
                this.rules = {};
                this.checkDetail();
            }
        }
    }
</script>
<style scoped>
    .zhanghu {
        margin-bottom: 40px;
    }

    .imgBox {
        width: 100%;
    }

    .bannerBox {
        width: 100%;
        padding: 0.22rem 0.38rem 0 0.32rem;
        margin: 0 auto;
    }

    .whiteBox {
        width: 100%;
        padding: 0.22rem 0.26rem;
        background-color: #ffffff;
    }

    .titles {
        font-size: 0.16rem;
        color: #0e75e9;
        position: relative;
        padding-left: 9px;
        border-left: 0.05rem solid #0e75e9;
        font-weight: bold;
    }
</style>
<style>
    .passfollow {
        position: absolute;
        right: 0;
        bottom: 0.3rem;
        background-color: #2785e7;
        color: white;
    }
	.gccolor {
	    color: rgb(255, 36, 36)!important;
	}
    .gccolor .el-form-item__label {
        color: rgb(255, 36, 36);
    }

    /*    .signsign .h-formbLine .el-form-item__content .el-select {
        width: 100% !important;
    } */

    .zhanghu .h-formbLine .el-form-item__label,
    .signsign .h-formbLine .el-form-item__label {
        width: 44%;
    }

    .signsign .h-formbLine .h-elformWrap-3 .el-form-item__label {
        width: 12.5%;
    }

    .signsign .h-formbLine .h-elformWrap-3 {
        width: 100%;
        padding-right: 0;
    }

    .signsign .h-formbLine .h-elformWrap-3 .el-form-item__content {
        width: 87.5%;
    }

    .signsign .h-formbLine .h-elformWrap-1 .el-form-item__label {
        width: 0%;
    }

    .signsign .h-formbLine .h-elformWrap-1 .el-form-item__content {
        width: 100%;
    }

    .zhanghu .h-formbLine .el-form-item__content,
    .signsign .h-formbLine .el-form-item__content {
        width: 56%;
    }

    .zhanghu .h-formbLine .h-elformWrap-2,
    .signsign .h-formbLine .h-elformWrap-2 {
        width:25%;
        padding-right: 0
    }

    .weekplandetail11 .h-formbLine .el-form-item__label {
        width: 61%;
    }

    .weekplandetail11 .h-formbLine .el-form-item__content {
        width: 39%;
    }
    .weekplandetail11 .h-formbLine .el-form-item.HAVES-2 .el-form-item__label {
        width: 10%;
    }

    .weekplandetail11 .h-formbLine .el-form-item.HAVES-2 .el-form-item__content {
        width: 90%;
    }

    .bannerBox2 .el-form-item__content {
        width: 85%;
    }

    .bannerBox2 .el-input__inner {
        border: none;
        border-bottom: 1px solid #DCDFE6;
    }
    .qudoa{
      font-size: 0.18rem;
      color: #868686;
      line-height: 0.28rem;
      width: 0.5rem;
    }
    .foundation-box{
      font-size: 0.18rem;
      color: #868686;
      line-height: 0.28rem;
    }
</style>
<style scoped>
/deep/ .h-formbLine .h-elformWrap-5{
  width: 30%!important;
  margin-left: 10%
}
/deep/.h-formbLine .h-elformWrap-5 .el-form-item__content {
  width: 90%;
}
</style>
